import './global.js'
import './singlepost.css'
import Parse from 'parse';
import React, { useState, useEffect } from 'react';
//import Recipe from "./recipe.jsx";
//import Product from "./product.jsx";
import { Route, Link} from "react-router-dom";
import $ from "jquery";
import { MentionsInput, Mention } from 'react-mentions';
import defaultStyle from './defaultStyle'
import defaultMentionStyle from './defaultMentionStyle'
import './MentionTextarea.css';
//import Modaldata from "./Modaldata.jsx";
import Picker from 'emoji-picker-react';
import FollowersUser from "./followersUser.jsx";
import PostSaveUser from "./postSaveUser.jsx";
import GetLikePostHome from "./getLikePostHome.jsx";
import Leftsidebar from "./Leftsidebar.jsx";
import SaveNotification from "./saveNotification.jsx";

  function time_ago(time) {

    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 's', 1], // 60
      [120, '1m', '1 minute from now'], // 60*2
      [3600, 'm', 60], // 60*60, 60
      [7200, '1h', '1 hour from now'], // 60*60*2
      [86400, 'h', 3600], // 60*60*24, 60*60
      [172800, '1d', 'Tomorrow'], // 60*60*24*2
      [604800, 'd', 86400], // 60*60*24*7, 60*60*24
      [1209600, '1w', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'w', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, '1m', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'm', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, '1y', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'y', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
   
    ];
    var seconds = (+new Date() - time) / 1000,
      token = '',
      list_choice = 1;

    if (seconds == 0) {
      return ''
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      //token = 'from now';
      token = '';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
          return Math.floor(seconds / format[2]) + '' + format[1] + '' + token;
      }
    return time;
  }


  class SinglePost extends React.Component {
      constructor(props) {
        super(props);

        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
        var now = new Date();
        
        this.state = {
            postID: 0,
            postData: null,
            created_at: now.getTime(),
            comments: null,
            postImage: null,
            userImage: null,
            user: null,
            caption: null,
            likeCount: 0,
            saveCount: 0,
            commentCount: 0,
            recipe: null,
            product: null,
            city: null,
            postcomment:'',
            isChallenge: "0",
            CurrentSaveCount: 0,
            currentuserImage: null,
            currentUserId: null,
            singlelikeCount:0,
            isExpanded:false,
            expandedCommentId:null,
            blank_comment_message:null,
            challengeStatus: null,
            singlementioned:'',
            singleget_allusers:[],
            linkdata:'',
            loadpage:'home',
            getUsernamefetch:null,
            usertype:0,
            popup_username:null,            
            popup_comments:null,
            commentsdatas:[],
            likeCount1: 0,
            likeuserlist:[],
            single_post_id:null,
            bufferdatalist:[],
            singlemodalstates:false,
            isPopupOpen: false,
            postDetails: null,
            loading: false,
            error: null,
            postDetailscomment: null,
            singlementioned_popup:'',
            singleget_allusers_popup:[],
            postcomment_popup:'',
            blank_comment_message_popup:null,
            followersListing: {},
            followinguserid:[],
            inputText: '',
            showPicker: false,
            reply_id:'',
            loadingdata:false,
            singlelikeCountChild:0,
            loader:false,
            reply_thread_id:'',
            followinglikeuserid:[],
            followerslikeListing: {},
            isHideEntry:0,
            isNotificationOpen:false,
            post_Notification_Id:'',
            post_Notification_Msg:'',
            post_Notification_Comment:''


        };

        //load vals from post objects

        //temp cheese
        var result = props.postData;

        //console.log("********************************");
        // console.log("RESULT: ", JSON.stringify(result));
        // console.log("USER: ", JSON.stringify(result.get("user")));
        // console.log("================================");
        // if (result.get("user") != undefined)
        //  console.log("Username: ", result.get("user").get("displayUsername"));
        // else
        //   console.log("UNDEFINED USER");
        
        if (result.get("image"))  {
          //console.log("Image: ", result.get("image").url());
          this.state.postImage = result.get("image").url();
        }
        if (result.get("isChallenge")) {
          //console.log("Image: ", result.get("image").url());
          this.state.isChallenge = result.get("isChallenge");
        }
      
        this.state.user = result.get("user");
        const currentUser = Parse.User.current();

        if(currentUser != null) {
          if((currentUser.get("isCreator")!==undefined && currentUser.get("isCreator")===1) || (currentUser.get("isBusiness")!==undefined && currentUser.get("isBusiness")===1) || (currentUser.get("isAdmin")!==undefined && currentUser.get("isAdmin")==="1"))
          {
            this.state.usertype=1;
          }

        
        }
        
        this.state.username = result.get("user").get("displayUsername");
        //new code
        if(this.state.user)
        {
          this.state.getUsernamefetch= this.state.username;
          if ((!this.state.getUsernamefetch) || (this.state.getUsernamefetch.length < 2)) 
          {
            this.state.getUsernamefetch = this.state.user.get("firstName") + "_" + this.state.user.get("lastName");
            this.state.getUsernamefetch = this.state.getUsernamefetch.toLowerCase(this.state.getUsernamefetch);
          }
        }
        //new code

        if (result.get("user").get("profilePictureSmall")) {
          //console.log("User image: ", result.get("user").get("profilePictureSmall").url());
          this.state.userImage = result.get("user").get("profilePictureSmall").url();
          //console.log('profile  pic small');
          // console.log(result.get("user").get("profilePictureSmall").url());
        } else {
            this.state.userImage ="/images/default_userpic0.png";
        }

        
        this.state.caption = result.get("caption");
        this.state.created_at = result.get("createdAt");
        this.state.city = result.get("user").get("city");

        var likeCount = result.get("likeCountNew");
        //var likeCount1 = result.get("likeCountNew");
        var saveCount = result.get("saveCount");
        var commentCount = result.get("commentcount");
        var imprCount = result.get("impr");
        
        this.state.title = result.get("title");
        this.state.url = result.get("url");
        this.state.collabUser = result.get("collabUser");
        this.state.collabUsername = result.get("collabUsername");
        if (this.state.collabUser) { 
          result.get("collabUser").fetch();
        }

        if (!likeCount) likeCount = 0;
        if (!saveCount) saveCount = 0;
        if (!commentCount) commentCount = 0;
        if (!imprCount) imprCount = 1;

        this.state.likeCount = likeCount;
        
        this.state.saveCount = saveCount;
        this.state.commentCount = commentCount;
        this.state.imprCount = imprCount;
        this.state.postID = result.id;
        this.state.challengeStatus = result.get("challengeStatus");
        this.state.isChallengeEntry = result.get("isChallengeEntry");
        this.state.isChallengeWinner = result.get("isChallengeWinner");
        this.state.isRecipe = result.get("isRecipe");
        this.state.challenge_id = result.get("challenge")?result.get("challenge").id:'';
        this.state.barcolor = result.get("challenge")?result.get("challenge").get('barcolor')?result.get("challenge").get('barcolor'):'':''; 
        this.state.challengeentrystatus = result.get("challenge")?result.get("challenge").get('challengeStatus')?result.get("challenge").get('challengeStatus'):'':''; 

        this.state.postLink = "/posts/" + this.state.postID;
        this.state.recipe = result.get("recipeV2");
        this.state.product = result.get("productV2");
        this.state.isHideEntry =  result.get("hideEntry")?result.get("hideEntry"):'0';

        if (this.props.showComments && this.state.recipe)
          this.state.recipe.fetch();

        if (this.props.showComments && this.state.product)
          this.state.product.fetch();

        if (this.props.showComments) //detail view only
        {
            this.queryForComments();
            this.props.postData.increment("impr");
            this.props.postData.save();
            this.state.loadpage='single';
            this.singlegetAllUsers();
            imprCount++;
            this.props.postData.set("imprcount", imprCount);
            this.props.postData.save();
        }
        //this.popuprenderComments()
        this.updateInput = this.updateInput.bind(this);
        this.handleCommentPost = this.handleCommentPost.bind(this);
        this.handleCommentPostUpdate = this.handleCommentPostUpdate.bind(this);
        this.handleSavePost = this.handleSavePost.bind(this);
       // this.handleGetSavePost = this.handleGetSavePost.bind(this);
        this.handleFollowUser = this.handleFollowUser.bind(this);
        this.handleUnFollowUser = this.handleUnFollowUser.bind(this);
        //this.handleGetFollowUser = this.handleGetFollowUser.bind(this); 
        this.cancelText = this.cancelText.bind(this); 
        this.getUserProfileImage();
        this.handlePhotoLike = this.handlePhotoLike.bind(this);
        this.formatRenderComments = this.formatRenderComments.bind(this);
        this.handlePostModelOpen = this.handlePostModelOpen.bind(this);
        //this.handleGetLikePost = this.handleGetLikePost.bind(this);
        this.handlePhotoUnLike = this.handlePhotoUnLike.bind(this);  
        this.handlePhotoActivityLike = this.handlePhotoActivityLike.bind(this);
        this.handleGetActivityLikePost = this.handleGetActivityLikePost.bind(this);
        this.handlePhotoActivityUnLike = this.handlePhotoActivityUnLike.bind(this);
        this.handleRemoveSavePost = this.handleRemoveSavePost.bind(this);   
        this.handleNotLoginClick = this.handleNotLoginClick.bind(this);
        this.singlePostModalClass = this.singlePostModalClass.bind(this);
        this.singlePostLikeModal = this.singlePostLikeModal.bind(this);  
        this.singlePostLikeModalClose = this.singlePostLikeModalClose.bind(this);          
        this.toggleExpand = this.toggleExpand.bind(this);       
        this.deleteCommentId = this.deleteCommentId.bind(this); 
        this.checkDeleteComment = this.checkDeleteComment.bind(this);  
        this.deletePostId = this.deletePostId.bind(this); 
        this.checkDeletePost = this.checkDeletePost.bind(this);
        this.handleGetLikeUser = this.handleGetLikeUser.bind(this);
        this.renderDetailPage = this.renderDetailPage.bind(this);
        this.singlePostModalClose1 = this.singlePostModalClose1.bind(this);
        this.handleCommentPostPopup = this.handleCommentPostPopup.bind(this);
        this.updateInputPopup = this.updateInputPopup.bind(this);
        this.handleFollowMyProfile = this.handleFollowMyProfile.bind(this);
        this.onEmojiClick = this.onEmojiClick.bind(this);
        this.handlePhotoActivityLikeChild = this.handlePhotoActivityLikeChild.bind(this);
        this.handleGetActivityLikePostChild = this.handleGetActivityLikePostChild.bind(this);
        this.handlePhotoActivityUnLikeChild = this.handlePhotoActivityUnLikeChild.bind(this);
        this.replyComment = this.replyComment.bind(this);
        this.handleUnFollowMyProfile = this.handleUnFollowMyProfile.bind(this);
        this.handleFollowMyProfileLike = this.handleFollowMyProfileLike.bind(this);
        this.handleUnFollowMyProfileLike = this.handleUnFollowMyProfileLike.bind(this);
        //this.toggleNotification = this.toggleNotification.bind(this);
      }

      onEmojiClick = (event, emojiObject) => {
        this.setState((prevState) => ({
          //inputText: prevState.inputText + emojiObject.emoji,
          singlementioned_popup:prevState.singlementioned_popup + emojiObject.emoji,
          showPicker: false, // Optional: hide the picker after selection
        }));
      };

      togglePicker = () => {
        this.setState((prevState) => ({
          showPicker: !prevState.showPicker,
        }));
      };

      handleUnFollowMyProfileLike= (e) => {
     let datapost_id=e.target.dataset.id;
     var self = this;
        const currentUser = Parse.User.current();
        if(currentUser) {
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                let touser=result;
                var checksavequery = new Parse.Query('Activity');  
                checksavequery.equalTo('type', 'follow'); 
                checksavequery.equalTo('toUser', touser);
                checksavequery.equalTo('fromUser',currentUser);
                checksavequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } 
                              })
                              .then((deletedObject) => {
                                    setTimeout(() => {
                                      $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                                      $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                                       self.singlegetUsersCommentLike(datapost_id);
                                    },1000);
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
               }
           })
             //setTimeout(() => {
              //  self.singlegetUsersCommentLike(datapost_id);
              // },2000);
        }else
        {
            // $('#kitchenQrModal_btn').trigger('click');  
            return false;
        }


    }

     handleUnFollowMyProfile= (e) => {  
      var self = this;
     let datapost_id=e.target.dataset.id;
        const currentUser = Parse.User.current();
        if(currentUser) {
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                let touser=result;
                var checksavequery = new Parse.Query('Activity');  
                checksavequery.equalTo('type', 'follow'); 
                checksavequery.equalTo('toUser', touser);
                checksavequery.equalTo('fromUser',currentUser);
                checksavequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } 
                              })
                              .then((deletedObject) => {
                               
                                    setTimeout(() => {                                      
                                       self.singlegetUsersLike(datapost_id);
                                        $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                                        $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                                    },1000);
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
               }
           })
             //setTimeout(() => {
                       // self.singlegetUsersLike(datapost_id);
                         //$('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                         //$('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                    //   },1000);
        }else
        {
            // $('#kitchenQrModal_btn').trigger('click');  
            return false;
        }


    }

      handleFollowMyProfile = (e) => {
        let datapost_id=e.target.dataset.id;
        const currentUser = Parse.User.current();
          var self = this;
        if(currentUser) {
          var query = new Parse.Query('User');
          query.equalTo("objectId", datapost_id);
          query.first().then(function(result){
            if(result) {
              let touser=result;          
              var Activity = Parse.Object.extend("Activity");
              var activity = new Activity();
              activity.set('fromUser', currentUser);
              activity.set('toUser', touser);              
              activity.set('type', 'follow'); 
              activity.save().then((savedFile) => {
                 
                setTimeout(() => {
                  //$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
                  //$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
                 
                  self.singlegetUsersLike(datapost_id);
                  $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");

                  self.toggleNotification(touser,'started following you.','');
                  self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                  
                },1000);
              }).catch((error) => {
              });              
            }
          })
       
        } else {
          $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }
      handleFollowMyProfileLike = (e) => {
        let datapost_id=e.target.dataset.id;
        var self = this;
        const currentUser = Parse.User.current();
        if(currentUser) {
          var query = new Parse.Query('User');
          query.equalTo("objectId", datapost_id);
          query.first().then(function(result){
            if(result) {
              let touser=result;          
              var Activity = Parse.Object.extend("Activity");
              var activity = new Activity();
              activity.set('fromUser', currentUser);
              activity.set('toUser', touser);              
              activity.set('type', 'follow'); 
              activity.save().then((savedFile) => {
                setTimeout(() => {
                  //$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
                  //$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                  self.singlegetUsersCommentLike(datapost_id);  

                  
                },1000);
              }).catch((error) => {
              });              
            }
          })
         // setTimeout(() => {
            //self.singlegetUsersCommentLike(datapost_id);            
          //},2000);
        } else {
          $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }

      componentDidMount() {
       // console.log('componentDidMount')
        //this.fetchPostData();
        //this.handleCommentPostUpdate();
      }

      fetchData = async () => { 
        let photo_post_id=this.state.postID;
        var query = new Parse.Query('Activity');
        query.equalTo('photo', "Photo$"+photo_post_id);
        //query query1 = await query1.get(postId);
        query.equalTo("type", "comment");
        query.doesNotExist("activity");
        query.include("fromUser");
        query.include("photo");      
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
        query.ascending("_created_at");       
        //query.descending("_created_at");
        var self = this;
        query.find().then(function(result){
          if(result){
            self.setState({singlementioned_popup: ''});
            self.setState({comments: result});
            self.setState({commentCount:result.length});

            let commentdataresults1=[]; 
            for (var i = 0; i < result.length; i++) { 
              let userActivitylist=[];
              var comment = result[i];
              //console.log('comment comment');
              // console.log(comment);
              //console.log(comment[0]);
              //var commentdata=comment;
              /* const processedcommentData = comment.map((result) => {
                return {
                  id:result.id,
                  content:result.get('content'),
                  createdAt:result.get('createdAt'),
                  fromUser:result.get('fromUser'),
                  likeCount:result.get('likeCount'),
                  toUser:result.get('toUser'),
                  type:result.get('type'),
                  updatedAt:result.get('updatedAt'),
                };
              });*/
              //console.log(commentdata);
              var replyQuery = new Parse.Query('Activity');
              replyQuery.equalTo('photo', "Photo$"+photo_post_id);
              replyQuery.exists("activity");
              replyQuery.equalTo('activity', "Activity$"+comment.id);                        
              replyQuery.include("photo");
              replyQuery.ascending("_created_at");
              //replyQuery.descending("_created_at");
              replyQuery.find().then(function(result){
                if(result) {
                  const processedData = result.map((result) => {
                    return {
                      id:result.id,
                      content:result.get('content'),
                      createdAt:result.get('createdAt'),
                      fromUser:result.get('fromUser'),
                      likeCount:result.get('likeCount'),
                      toUser:result.get('toUser'),
                      type:result.get('type'),
                      updatedAt:result.get('updatedAt'),
                    };
                  });
                  userActivitylist.push(processedData);
                }              
              })                    
              commentdataresults1.push({comments:comment,
                children: userActivitylist,
              });
            }

            //setTimeout(() => {
            // self.setState({postDetailscomment: commentdataresults1,loadingdata:true});
            //},500);   
            //self.setState({comments: commentdataresults1});
            //self.setState({isPopupOpen: true});
            //isPopupOpen: true
            //self.setState({postDetailscomment: result});
            //self.renderDetailPage(photo_post_id);
          } else {
          }
        }, function(error){
        });
      }
      
      // Method to fetch post data from Parse
      fetchPostData = async (postId) => {  
        //console.log('fetchPostData'+postId);
        this.setState({ loading: true, error: null });
        try {
          const Post = Parse.Object.extend('Photo');
          const query = new Parse.Query(Post);
          const post = await query.get(postId);
          
          let userlikelist=[];
          var query1 = new Parse.Query('Activity');
          query1.equalTo('photo', "Photo$"+postId);
          query1.equalTo("type", "comment");
          query1.include("fromUser");
          query1.include("photo");
          query1.include("image");
          query1.include("content");
          query1.include("_created_at");
          query1.include("createdAt");

          query1.doesNotExist("activity");
          query1.ascending("_created_at");
          var self = this;
          
          query1.find().then(function(result){
            if(result) {  
                  
              let commentdataresults=[]; 
              for (var i = 0; i < result.length; i++) {
                let userActivitylist=[];
                var comment = result[i];
                var replyQuery = new Parse.Query('Activity');
                replyQuery.equalTo('photo', "Photo$"+postId);
                replyQuery.exists("activity");
                replyQuery.equalTo('activity', "Activity$"+comment.id);
                replyQuery.include("photo");
                replyQuery.ascending("_created_at");
                //replyQuery.descending("_created_at");
                replyQuery.find().then(function(result){
                  if(result) {  
                    const processedData = result.map((result) => {
                      return {
                        id:result.id,
                        content:result.get('content'),
                        createdAt:result.get('createdAt'),
                        fromUser:result.get('fromUser'),
                        likeCount:result.get('likeCount'),
                        toUser:result.get('toUser'),
                        type:result.get('type'),
                        updatedAt:result.get('updatedAt'),
                      };
                    });
                    userActivitylist.push(processedData);
                  }
                })
                commentdataresults.push({comments:comment,
                  children: userActivitylist,
                });

              }
              
              self.setState({
                postDetailscomment: commentdataresults,//result,
                postDetails: post,
                loading: false,
                loadingdata:true
              });
              let obj = post.get('caption')!=''?self.formatRenderComments2main(post.get('caption')):self.formatRenderComments2main(post.get('caption'));   
              let full_text=obj.a.props.children?obj.a.props.children:'';
              $('#full_text').html(full_text);
              $('#lef_img').attr('src','../images/default_userpic0.png');
              $('.popup_user_image').attr('src','../images/default_userpic0.png');
              $('.popup_display_userimage').attr('src','../images/default_userpic0.png');

              $('.user_name a.popup_user_name').html('');
              $('.user_name a.popup_user_name').html(post.get('user').get('displayUsername'));
              $('.user_name a.popup_user_name').attr("href", "/user/"+post.get('user').get('displayUsername')) ;
              $('.popup_display_username').html(post.get('user').get('displayUsername'));
              $('.popup_display_username').attr("href", "/user/"+post.get('user').get('displayUsername')) ;
              let userprofileimage=post?post.get('user')?post.get('user').get('profilePictureSmall')?post.get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';

              $('.popup_user_image').attr('src',userprofileimage);
              $('.popup_display_userimage').attr('src',userprofileimage);
              let photo_img =post?post.get('image')?post.get('image')?post.get('image').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';

              $('#lef_img').attr('src',photo_img);
              let likeCountNew=post.get('likeCountNew')?post.get('likeCountNew'):0;
              let likesWord = "Likes";
              if (likeCountNew == 1){likesWord = "Like"; } 
              $('#like_count_new').html(likeCountNew+' '+likesWord);
              $('.time_interval_new').html(time_ago(post.get('createdAt')));
              document.getElementById('large_challenge_image_btn22').click();

              self.singlegetAllUsersPopup();
              //
              self.handleGetSavePost(post.id,'popup');            
              self.singlegetUsersLike(post.id);
              self.handleGetLikeUser(postId);
              //count update
               var postimpt=post?post.get('impr')+1:1;
               post.set('impr', postimpt);
               post.save().then((postupdated) => {
               });
              //count update

              /*url update*/
              //let stateObj = { postId: postId }; 
              window.history.replaceState(window.history.state, "","/post/"+postId); 
              /*url update*/
            
            } else {
            }
            //$('#large_challenge_image2').trigger('click');
          
          }, function(error){
        });
       //comment listing 
          
      
        } catch (err) {
          this.setState({
          //error: 'Failed to fetch post data',
          loading: false,
          });
        }
      };
      faqOpenClose(commentId) {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];
        var self = this;
        var check = $(".view_replies_comment .faq-drawer #faq-drawer-"+commenUpdatedId).is(":checked");
        if(check) {
          $(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('Hide Replies');
         
          $('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).addClass('active');
        } else {
          $(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('View Replies');
          if ($('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).hasClass("active")) {
            $('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).removeClass('active');
          }
        }
      }
      openPopup = (postId) => {
        $('#popup_post_id').val(postId);
        this.setState({ isPopupOpen: true }, () => {
          this.fetchPostData(postId);
        });
      };


      
       hometaps = async (postId,challengeId) => {
        var getPhotoquery = new Parse.Query('Photo');  
        getPhotoquery.equalTo('objectId', postId);
        getPhotoquery.first().then(function(photo){
          if(photo) {
            let homeCount =photo.get('homeCount')?photo.get('homeCount'):0;
            if(homeCount)
            {
               var updated_comment_count=parseInt(homeCount)+1;
            }else{
              var updated_comment_count=1;
            }
            
            photo.set("homeCount", updated_comment_count.toString());
            photo.save().then((photodata) => {
               window.location.href = '/challenge/'+challengeId;
                     }).catch((error) => {
                        console.log(error.message);
                     }); 
            
           
          }
        })
       /* setTimeout(() => {
        
       }, 1500);*/
       }

      //handleCommentPostUpdate = function(e){
      //  handleCommentPostUpdate  = () => {
      
      handleCommentPostUpdate = async () => { 
        //$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");   
        //$('.add_in_comment #comment_box_popup').attr("style", "color: transparent");
        //$('.add_in_comment #comment_box_popup').attr('placeholder','Add a comment...');
        let photo_post_id=this.state.postID;
        let reply_thread_id=this.state.reply_thread_id;
        var self = this;

        var query = new Parse.Query('Activity');
        let reply_id=this.state.reply_id;
        query.equalTo('photo', "Photo$"+photo_post_id);
        query.equalTo("type", "comment");
        query.doesNotExist("activity");
        query.include("fromUser");
        query.include("photo");
        query.limit(999999999);
        
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
      
        //query.descending("_created_at");
        query.ascending("_created_at");
        let commentCountval=this.state.commentCount;
        
        query.find().then(function(result){
          let commentdataresults1=[]; 
          if(result){
            let totalcomment=result.length;
            let totalcommentchild=0;
            self.setState({singlementioned_popup: ''});
            self.setState({comments: result});
              
            for (var i = 0; i < result.length; i++) {    
              let userActivitylist=[];
              var comment = result[i];  
              var comment_idsval=comment.id;
              var replyQuery = new Parse.Query('Activity');
              replyQuery.equalTo('photo', "Photo$"+photo_post_id);
              replyQuery.exists("activity");
              replyQuery.equalTo('activity', "Activity$"+comment.id);
              replyQuery.include("photo");
              replyQuery.ascending("_created_at");
             // replyQuery.descending("_created_at");
              replyQuery.find().then(function(result) {

                if(result) {
                  //totalcommentchild=result.length;
                  var processedData = result.map((result) => {
                    return {
                      id:result.id,
                      content:result.get('content'),
                      createdAt:result.get('createdAt'),
                      fromUser:result.get('fromUser'),
                      likeCount:result.get('likeCount'),
                      toUser:result.get('toUser'),
                      type:result.get('type'),
                      updatedAt:result.get('updatedAt'),
                    };
                  });
                  userActivitylist.push(processedData);
                }  

                //self.handleGetActivityLikePostChild(comment_idsval) ; 
                //self.handleGetActivityLikePost(result.id); 
              })    

              commentdataresults1.push({comments:comment,
                children: userActivitylist,
              });
              
              /*setTimeout(() => {
                if(comment.id) {
                  // $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                    self.handleGetActivityLikePostChild(comment.id)
                }
              },1000); */
            }

            setTimeout(() => {
              self.setState({ postDetailscomment: commentdataresults1 }, () => {
                self.setState({loadingdata: true,loading: false,singlementioned_popup: '',loader:false,reply_id: '' });
              });
              if(reply_thread_id) {
                $(' a.liked_activity_child .activitydefault#comment_'+reply_thread_id).attr("style", "display: block");
                $('a.liked_activity_child .activityactive#comment_'+reply_thread_id).attr("style", "display: none");
                $('.like.box .count#childlike_'+reply_thread_id).html(0);  
                $('.like.box .like_count#childlike_'+reply_thread_id).html('Likes'); 
              }
              self.setState({ reply_thread_id: '' });
               setTimeout(() => {
                          self.handleCommentPostLikes();  
                          $('#activity_parent_id').val(''); 
                        },500); 
               $('.post_button_comment#handleCommentPost_popup').attr("disabled", false);
            },3500); 

            $('#reply_id').val('');
          
            //self.setState({ reply_id: '' });
            //self.setState({singlementioned_popup: ''});
            //self.setState({commentCount:totalcomment});
            //console.log('totalcomment'+totalcomment)
            //self.setState({postDetailscomment: result});
            //self.renderDetailPage(photo_post_id);
            /*setTimeout(() => {
                if(commentdataresults1) {
                  for (var i = 0; i < commentdataresults1.length; i++) {
                    var commentdataresults1 = commentdataresults1[i]; 
                    let comment= commentdataresults1.comments; 
                    console.log('comment');
                    console.log(comment);
                    console.log('.comment_like  .comment.box a .reply_count#comnt_'+comment.id);
                    $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                  }
                }
              },1000); */                  
            /*setTimeout(() => {
              self.setState({reply_id: ''});
              $('#reply_id').val('');
              $(".add_in_comment #comment_box_popup").val('');
              self.setState({singlementioned_popup: ''});
                $('#clearInput').trigger('click');                 
              },2000); */  
          } else {
          }
        }, function(error){});
        var getPhotoquery = new Parse.Query('Photo');  
        getPhotoquery.equalTo('objectId', photo_post_id);
        var self = this;
        getPhotoquery.find().then(function(photo){
          if(photo) {
            let photo_ob=photo[0];
            let commentcount =photo_ob.get('commentcount')?photo_ob.get('commentcount'):0;
            self.setState({commentCount:commentcount});
            photo_ob.set("commentcount", commentcount.toString());
            photo_ob.save();
          }
        }) 
        
      } 
 handleCommentPostLikes = () => {
         let post_id=this.state.postID;
         const currentUser = Parse.User.current();
         if (currentUser) {
            const currentUser_id = currentUser.id;     
             var query_activityChild = new Parse.Query('Activity'); 
             query_activityChild.equalTo('photo', "Photo$"+post_id); 
             query_activityChild.exists("activity");
             query_activityChild.find().then((resultactivity) => {

             let resultactivitys=resultactivity;
               for (const objects of resultactivitys) {
                        setTimeout(() => {
                          if(objects.get('likeCount')===0){  
                             $('a.liked_activity_child .activityactive#comment_'+objects.id).attr("style", "display: none"); 
                              $('a.liked_activity_child .activitydefault#comment_'+objects.id).attr("style", "display: block");
                              $('.like.box .count#childlike_'+objects.id).html(0);  
                              $('.like.box .like_count#childlike_'+objects.id).html('Likes');
                          }
                    },1000);
                  }
          })
          }
     }
      // Method to handle closing the popup
      closePopup = () => {
        this.setState({
          isPopupOpen: false,
          postDetails: null,
          postDetailscomment: null,
          postDetailsReplycomment: null,
        });
      };
      
      replyComment = (commentId,activity_parent_id,event) => {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];

        $('#reply_id').val(commenUpdatedId);  
        $('#activity_parent_id').val(activity_parent_id); 
        this.setState({reply_id: commenUpdatedId});
        let reply_id=$('#reply_id').val();
        var query1 = new Parse.Query('Activity');
        query1.equalTo('objectId', commenUpdatedId);
        query1.equalTo("type", "comment");
        query1.include("fromUser");
        var self = this;
        $('.add_in_comment #comment_box_popup').val('');            
        let activity_parent_ids=$('#activity_parent_id').val();

        query1.find().then(function(photo){
          if(photo) {
            let photo_ob=photo[0];
            let displayusername=photo_ob?photo_ob.get('fromUser')?'@'+photo_ob.get('fromUser').get('displayUsername')+'  ':'':'';
            let displayusernameval=photo_ob?photo_ob.get('fromUser')?photo_ob.get('fromUser').get('displayUsername'):'':'';
            
            self.setState({singlementioned_popup:displayusername}); 
              
          }
        });
        setTimeout(() => {
          if(activity_parent_ids==='' && reply_id==='') {
            self.setState({singlementioned_popup:''}); 
              $('#clearInput').trigger('click');
          }            
        },2000); 
        $('.add_in_comment #comment_box_popup').focus(); 
      }

      renderDetailPage = (post_id) => {
        const { postDetails,postDetailscomment,likeuserlist,inputText, showPicker,postDetailsReplycomment,loadingdata,loader } = this.state;
        let othertext='';
        let bufferdata = [];
        let bufferdatacommentreply = [];   
        let userlikeusername = [];
        let fetchuserlikeusername = [];
        let bufferfollowers=[];
        let bufferlikefollowers=[];
        const formatRenderCommentChild  = (origComment,comnt_id, comment_id) => {  
          let buffer = [];
          if (!origComment) {
            return (
              <div>
                {buffer}
              </div>
            );
          }

          var stringSplit = origComment.split(" ");
          var maxLength=250;

          for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);
             var self = this;
            if (firstChar == "#") {
              buffer.push(comp);
            } else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1)) {
              buffer.push(comp);
            } else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1)) {
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
              buffer.push(linkdata);  
            } else {
              buffer.push(comp);               
            }
          }
          
          var content=buffer.join(' ');
          const {  showMoreText = 'more', showLessText = 'less' } = this.props;
          const { isExpanded } = this.state;
          const { expandedCommentId } = this.state;
          const shouldTruncate =content.length > maxLength && !isExpanded;
           
          let  displayText =  shouldTruncate ? content.slice(0, maxLength) + '...' : content        
          return (
            <span className='cmt-txt' id={comment_id}>
              {/*displayText*/}<span dangerouslySetInnerHTML={{ __html: displayText }} />
              {shouldTruncate   && (
                <button onClick={() => this.toggleExpand(comment_id)} style={{ color: '#868589', cursor: 'pointer', border: 'none', background: 'none' }}>
                    {isExpanded ? showLessText : showMoreText}
                </button>
              )}
            </span>
          );
        }

       

        const clearInput = () => {
          var self = this;
          //this.setState({ inputValue: '' });
          self.setState({singlementioned_popup: ''});
        };

        const getCommentProfilePicChild = (comment) => { 
          var user = comment.fromUser;
          if (user && (user != undefined)) {
            var pic = user.get('profilePictureSmall');
            if (pic && (pic != undefined))
              return pic.url()
          }
          return "/images/default_userpic0.png";
        }
        
        if(this.state.postDetailscomment) {
          if(this.state.postDetailscomment.length>0) {
            let buffercommentdata = [];  
            for (var i = 0; i < this.state.postDetailscomment.length; i++) {
              var comment = this.state.postDetailscomment[i]; 

              let children= comment.children!==undefined?comment.children[0]:''; 
              comment= comment.comments;
              
              let comment_activity_id="comment_"+comment.id;
              let comment_id="comnt_"+comment.id;
              let comment_par_id="comnt_"+comment.id;
              let likeCount=comment.get("likeCount")?comment.get("likeCount"):0;
              var likesWord = "Likes";
              if (likeCount == 1) likesWord = "Like";
              let comment_fromuserid= comment.get("fromUser")?comment.get("fromUser").id:'';
              let comment_currentUserId= this.state.currentUserId;
              const hasKey = comment.has('activity');  
              //console.log(i);
              var self = this;
              let main_activity_id=comment.id;

              
              
              bufferdata.push(               
                <div key={69*i} className="cmt_wrap">
                  <div className="detail_bottom user_top_row">
                    <div className="user_top_card">
                    
                      {hasKey==false?
                        <div className="user_inline_row">
                          <div className="user_leftbar_img">
                            <div className="user_img">
                              <span className="user_icon">{/*<img src="../images/default_userpic0.png" alt='img'/>*/} <img src={this.getCommentProfilePic(comment)}/>  </span>
                            </div>
                            <div className="user_name_wrapper">
                              <div className="user_inner">
                                <div className="user_name">
                                  {comment.get("fromUser")?comment.get("fromUser").get('displayUsername')?<a href={'/user/' + comment.get("fromUser").get('displayUsername')}>{comment.get("fromUser").get('displayUsername')}</a>:'':''} 
                                  {hasKey==false?
                                  <span className="content-span">  <span className="cmt_cnt" id={comment_id}>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)}</span></span>:<span>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)} </span> }
                                </div>
                                <div className="user_sidebar_heart">
                                  {this.handleGetActivityLikePost(comment.id)}

                                  {likeCount==0?
                                    <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                                      <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e)}}  className="activitydefault" src="../images/cmt-like.svg"/>
                                    </a>
                                    :
                                    <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                                      <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityUnLike(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>
                                      <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e);}}  className="activitydefault" src="../images/cmt-like.svg"/>
                                    </a>
                                  }
                        
  <div className="like box maincomment"   id={comment.id}   style={({display: likeCount===0 ? 'none' : 'block'})}
                                       >
                                        {/*type="button" data-toggle="modal" data-target="#large_challenge_like_list_likes"*/}
                                        <a href="javascript:;" id="like_button_challenge"  onClick={(e)=> { this.singlePostLikeModalLikes(main_activity_id,false)}} ><span className="count">{likeCount}</span><span className="like_count"   style={{ display: "none" }}>{likesWord}</span></a>
                                      </div>
                                </div>
                                
                              </div>
                              <div className="product_content_details">
                                                           
                                {
                                  hasKey==false?
                                    <div className="comment_like d-flex flex-row flex-wrap align-items-center"  id={comment_id}>
                                      <div className="day box">
                                        {/*  <a href="javascript:;"><span className="count">6</span><span className="days">d</span></a>*/}
                                        {time_ago(comment.get("createdAt"))}
                                      </div>
                                     
                                      <div className="comment box" >
                                        <a href="javascript:;"><span className="reply_count" id={comment_id}   onClick={(e) => this.replyComment(comment_id,main_activity_id,e)}  >Reply</span></a>
                                      </div>
                                      <div className="comment box"   style={{ display: "none" }}>
                                        <div className="action cta_btn">
                                          <div className="btn-wrp btn-group more_action three-dot" >
                                            <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                              <img src="/images/small_dot_action.svg" alt="More Option"/>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                        
                                              {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button"  onClick={(e) => this.deleteCommentIdOverlay(comment_id)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report </a> }
                                              <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>                           
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                    </div>
                                  : 
                                    <div>
                                    </div>
                                  
                                }
                                {/*start reply*/}
                                {/*loadingdata && children &&  children.map(function (child, i, row) {{ return (  <div className="content">{child.content}fafafff</div>) } })*/}
                                {children!==undefined && children.length>0 && 
                                  <div className="view_replies_comment">
                                    {/*bufferreplydata*/}
                                    <div className="faq-drawer">
                                      <input className="faq-drawer__trigger" id={"faq-drawer-"+comment.id} type="checkbox" title={comment_id} onClick={(e) => this.faqOpenClose(comment_id)}  /><label className="faq-drawer__title" htmlFor={"faq-drawer-"+comment.id} ><span id={"faq-"+comment.id}>View Replies </span> <span className="replies_count"  id={"faqreply-"+comment.id}>({children.length})</span> </label>
                                      <div className="faq-drawer__content-wrapper"  id={"fq-"+comment.id}>
                                        <div className="faq-drawer__content">
                                          <ul className="ul_list_replay_user">
                                            {
                                              loadingdata && children &&  children.map( function (child, i, row) {
                                                { 
                                                  let comment_fromuserid= child.fromUser.id;
                                                  const currentUser = Parse.User.current();
                                                  let comment_currentUserId='';
                                                  if (currentUser) {
                                                    comment_currentUserId= currentUser.id;
                                                  }
                                                  //console.log('child');
                                                  //console.log(child);
                                                  //self.state.singlementioned_popup='';
                                                  let comment_activity_id_child="comment_"+child.id;
                                                  let comment_id_child="comnt_"+child.id;
                                                  let likeCountChild=child.likeCount?child.likeCount:0;
                                                  //this.state.singlelikeCountChild=child.likeCount?child.likeCount:0;
                                                  //console.log(likeCountChild+'likeCount children');
                                                  var likesWord = "Likes";
                                                  
                                                  if (likeCountChild == 1) likesWord = "Like";
                                                  
                                                  return (
                                                    <li className="li_list_replay_user"  key={69*i}>
                                                      <div className="comment_replay_row">
                                                        <div className="comment_replay_inner">
                                                          <div className="comment_userimg_inner">
                                                            <div className="comment_user_img">
                                                              <img src={getCommentProfilePicChild(child)}/>
                                                            </div>
                                                            <div className="comment_content_inner">
                                                              <div className="content_replay">
                                                                <span className="title_userName"> {child.fromUser?child.fromUser.get('displayUsername')?<a href={'/user/' + child.fromUser.get('displayUsername')}>{child.fromUser.get('displayUsername')}</a>:'':''} </span>  <span className="content-span">  <span className="cmt_cnt" id={comment_id_child}>{formatRenderCommentChild(child.content,comment_id_child,child.id)}</span>
                                                                </span>
                                                              </div>
                                                              <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                                <div className="day box">
                                                                  <a href="javascript:;">{time_ago(child.createdAt)}</a>
                                                                </div>
                                                                
                                                                <div className="comment box">
                                                                  <a href="javascript:;"><span className="reply_count" id={comment_id_child}   onClick={(e) => self.replyComment(comment_id_child,main_activity_id,e)}  >Reply</span></a>
                                                                </div>
                                                                <div className="comment box"    style={{ display: "none" }} >
                                                                  <div className="action cta_btn">
                                                                    <div className="btn-wrp btn-group more_action three-dot dropup">
                                                                      <button type="button" id="comment_dropdownlist1" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                        <img src="/images/small_dot_action.svg" alt="More Option"/>
                                                                      </button>
                                                                      <div className="dropdown-menu">
                                                                      {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button"  onClick={(e) => self.deleteCommentIdOverlay(comment_id_child)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report </a> }
                                                                        <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>                           
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                               
                                                              </div>
                                                            </div>
                                                            <div className="comment_user_content">
                                                           
                                                              <a  href = "javascript:void(0);"  className='liked_activity_child'  id={comment_activity_id_child} >
                                                                <img data-id={child.id} id={comment_activity_id_child}  onClick={(e) => {self.handlePhotoActivityUnLikeChild(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>            
                                                                <img data-id={child.id} id={comment_activity_id_child}  onClick={(e) => {self.handlePhotoActivityLikeChild(e);}}  className="activitydefault" src="../images/cmt-like.svg" style={{ display: "block" }} />
                                                              </a>
                                                              {self.handleGetActivityLikePostChild(child.id,child)}
                                                              {/*}*/}
                                                               <div className="like box childcomment" id={"child_"+child.id}    style={({display: likeCountChild===0 ? 'none' : 'block'})}>
                                                                  {/*type="button" data-toggle="modal" data-target="#large_challenge_like_list"  onClick={self.singlePostLikeModal} data-toggle="modal" data-target="#large_challenge_like_list"*/}
                                                                  <a href="javascript:;"  id="like_button_challenge"   onClick={(e)=> { self.singlePostLikeModalLikes(child.id,false)}} ><span className="count" id={"childlike_"+child.id}>{likeCountChild}</span><span className="like_count"   style={{ display: "none" }}  id={"childlike_"+child.id}>{likesWord}</span></a>
                                                                </div>
                                                            </div>
                                                             
                                                          </div>
                                                          
                                                        </div>
                                                      </div>
                                                    </li>
                                                  );
                                                }
                                              })
                                            }
                                          
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>  
                                }
                                {/*end reply*/}                                  
                              </div>
                            </div>
                          </div>
                        </div>
                      : ''}
                    </div>
                  </div>
                
               
                </div>
              );
            }
          }
        }
        
        if (this.state.likeuserlist) {    
          var rows = this.state.likeuserlist.length;
          var other=0;
          
          for (var i = 0; i < rows; i++) {  
           var likeuser = this.state.likeuserlist[i]; 
           if(rows>1) { 
            other=rows-1;  
           }  
           if(i==0)
           {
                if (likeuser.get('fromUser') && likeuser.get('fromUser').id!==undefined){
              userlikeusername.push(<span  key={69*i}>
                      <a href={'/user/'+likeuser.get('fromUser').get("displayUsername")} id="like_button_challenge" onClick={this.singlePostLikeModal} type="button" data-toggle="modal" data-target="#large_challenge_like_list">  {likeuser.get('fromUser').get("displayUsername")}</a>
                      </span>); 
            }
           }
        }
           
        if(userlikeusername)
        {
            fetchuserlikeusername.push(<span  key={69*i}>{userlikeusername!=''?<p className="liked_others"><label>Liked by  {userlikeusername} {rows>1 && other?other==1?<span> and <a id='like_button_challenge' onClick={this.singlePostLikeModal}  type='button' data-toggle='modal' data-target='#large_challenge_like_list'>{other}</a>  other </span>:<span> and <a id='like_button_challenge' onClick={this.singlePostLikeModal}  type='button' data-toggle='modal' data-target='#large_challenge_like_list'>{other}</a>  others </span>:""} </label></p>:''}</span>);  
            /**/       
        }
    }
    if(this.state.followersListing) {

      let followinguserid=this.state.followinguserid;           
      var following_match_id=[];                    
      var rows = this.state.followersListing.length;
      if(rows != undefined){
        for (var i = 0; i < rows; i++) {
          var followers = this.state.followersListing[i];
          var follow_id_ms='followpopup_'+followers.id;

          let userimage=null; 
          if(followers.image) {
            userimage=followers.image;
          } else {
            userimage="/images/default_userpic0.png";
          }
          const currentUser = Parse.User.current();  
                    if(currentUser)
                    {
                      let   currentUserid=currentUser.id;
                     var chek = followinguserid.find(c =>{ return c.id === followers.id});//'K1iL8XNQOd'  
                     
                  
                    var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                
                                bufferfollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                
                                      {currentUserid===followers.id?"":followingresults.id===followers.id?<a href="javascript:void(0);"  className="following_user follow_button "  id={follow_id_ms}  title="UnFollow"   data-id={followers.id}       onClick={(e) => this.handleUnFollowMyProfile(e)}  >Unfollow</a>: <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => this.handleFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>}
                                    </div>
                                  </li>
                                );
                                }else{
                                  // var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                                bufferfollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                    {/* <a href="javascript:;" className="following_user follow_button ">Following</a>
                                      <a  href="javascript:;" className="follow_user follow_button" style={{ display: "none" }} >Follow</a>*/}
                                      <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => this.handleFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>
                                    </div>
                                  </li>
                                );

                    }
                    
           }
            } 
        }

      if(this.state.followerslikeListing) {

      let followinguserid=this.state.followinglikeuserid;           
      var following_match_id=[];                    
      var rows = this.state.followerslikeListing.length;
      if(rows != undefined){
        for (var i = 0; i < rows; i++) {
          var followers = this.state.followerslikeListing[i];
          var follow_id_ms='followpopup_'+followers.id;

          let userimage=null; 
          if(followers.image) {
            userimage=followers.image;
          } else {
            userimage="/images/default_userpic0.png";
          }
          const currentUser = Parse.User.current();  
                    if(currentUser)
                    {
                      let   currentUserid=currentUser.id;
                     var chek = followinguserid.find(c =>{ return c.id === followers.id});//'K1iL8XNQOd'  
                     
                  
                    var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                
                                bufferlikefollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                 
                                      {/*currentUserid===followers.id?"":followingresults.id===followers.id?<a href="javascript:void(0);"  className="following_user follow_button ">Following</a>: <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => this.handleFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>*/}
                                      {currentUserid===followers.id?"":followingresults.id===followers.id?<a href="javascript:void(0);"  className="following_user follow_button "  id={follow_id_ms}  title="UnFollow"   data-id={followers.id}       onClick={(e) => self.handleUnFollowMyProfileLike(e)}  >Unfollow</a>: <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>}
                                    </div>
                                  </li>
                                );
                                }else{
                                  // var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                                bufferlikefollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                    {/* <a href="javascript:;"  id={follow_id_ms}  className="following_user follow_button ">Following te</a>
                                      <a  href="javascript:;" className="follow_user follow_button" style={{ display: "none" }} >Follow</a>*/}
                                      <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>
                                    </div>
                                  </li>
                                );

                    }
                    
           }
            } 
        }


        let getLoggedinUsername=localStorage.getItem('username');
        var post_id_m='save_'+post_id;
        var follow_id_m='follow_'+this.state.user.id;
        var currentuserImage=this.state.currentuserImage;
        var post_like_id_m='like_'+post_id;
        var currentUserId=this.state.currentUserId;
        let sameprofile=0;
        if(currentUserId===this.state.user.id) {
          sameprofile=1;
        } 
        

    return ( 
    <React.Fragment>      
      <div className="modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image" id="large_challenge_image3" data-backdrop="false" data-keyboard="true" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true" >
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className='action-part'>
            <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' onClick={this.singlePostModalClose1} data-dismiss="modal" aria-label="Close" title='Close'>&#x2715;</a>
          </div>
            <div className="modal-body"> 

            <button style={{display:"none"}} href='javascript:void(0);'  type="button" className='btn' data-toggle="modal" data-target="#large_challenge_like_list_likes1"  id="large_challenge_like_list_likes">get </button>

 
          

              <div className='inner text-center'>
              <div className="inner_post_row">
                <div className="img_leftSide">
                {/* <img src="../images/default_userpic0.png" alt='Comment'/>*/}
                <img id="lef_img" src="../images/default_userpic0.png" alt='Comment'/>
                </div>
                <div className="right_side_content_post">
                  <div className="user_top_row border_bottom">
                    <div className="user_top_card">
                      <div className="user_img">
                        <span className="user_icon"><img className="popup_user_image" src="../images/default_userpic0.png" alt='img'/>{/*<img src="../images/default_userpic0.png" alt='img'/>*/}</span>
                      </div>
                      <div className="user_name">
                      <a  className="popup_user_name" href="#"></a>
                    
                      </div>
                    </div>
                    <div className="action cta_btn">
                      <div className="btn-wrp btn-group more_action three-dot">
                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <img src="/images/dot_action.svg" alt="More Option"/>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                       
                          {sameprofile===1?<div className="post_delete_cm">
                         {/* <a href='javascript:void(0);'  aria-label="Close" className="dropdown-item" type="button" title="Edit">Edit</a>*/}
                          <a  href='javascript:void(0);'  className="dropdown-item danger" type="button" id="delete_post_with_discardpoup"   onClick={(e) => this.deletePostId(post_id)}  title="Delete"  data-toggle="modal" data-target="#deletePostCloseModalpopup" >Delete</a></div>
                          : <a  href='javascript:void(0);' className="dropdown-item danger" type="button">Report</a>}
                          <a href='javascript:void(0);'  aria-label="Close" className="dropdown-item" type="button"  title="Cancel" >Cancel</a>                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post_listing_ul_wrap">
                    <ul className="post_listing_ul">
                      <li className="post_listing_li">                        
                        <div className="detail_bottom user_top_row">
                          <div className="user_top_card">
                            <div className="user_inline_row">
                              <div className="user_leftbar_img">
                                <div className="user_img">
                                  <span className="user_icon">{/*<img src="../images/default_userpic0.png" alt='img'/>*/}<img  className="popup_display_userimage" src="../images/default_userpic0.png" alt='img'/></span>
                                </div>
                                <div className="user_name_wrapper">
                                  <div className="user_inner">
                                    <div className="user_name">
                                      {/* <a href="#">rosslynmarie</a> */}
                                      <div></div>
                                      <a href="javascript:;" className="popup_display_username"></a>
                                      <span className="cmt_box">
                                        <span className="cmt_cnt">
                                          <span className="cmt-txt" id="full_text"></span>
                                        </span>
                                      </span>
                                      <span className="content-span">
                                        {/* <div className="commentsContainer">
                                          <div className="home_pg">
                                          </div>
                                        </div> */}
                                      </span>
                                    </div>
                                    <div className="user_sidebar_heart"> </div>
                                  </div>
                                  <div className="product_content_details">
                                    <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                      <div className="day box">
                                        <a href="javascript:;">{/*<span className="count">6</span><span className="days">d</span>*/}<span className="time_interval_new"></span></a>
                                      </div>
                                      <div className="like box">
                                        <a href="javascript:;" id="like_button_challenge" onClick={this.singlePostLikeModal} type="button" data-toggle="modal" data-target="#large_challenge_like_list">{/*<span className="count">6</span>*/}<span id="like_count_new"></span>{}
                                        {/*this.state.likeCount1*/}{/*<span className="like_count">Likes</span>*/}</a>
                                      </div>
                                      <div className="comment box">
                                       {/* <a href="javascript:;" onClick={() => this.handleCommentClick()} ><span className="reply_countss">Reply</span></a>*/}
                                      </div>
                                     
                                    </div>
                                  </div>
                                </div>                              
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="post_listing_li">
                          {bufferdata}
                      
                      </li>
                    </ul>
                  </div>
                  <div className="comment_post_bottom_add">
                  {sameprofile===1 && this.state.isChallenge==0?   
                    <div className="create_challenge_row">
                    {/* <button className="create_button">Create Challenge</button>*/}
                                            
                        <a href={'/create-challenge/'+this.state.postID}  className="create_button" title='Create Challenge'>Create Challenge</a>
                        
                    </div>
                      :""}



                    <div className="comment_like_shere">
                      <div className="wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100">
                          <div className="action_grp">
                         
                                <input type="hidden" id="popup_post_id" name="popup_post_id" value={post_id} />
                                <input type="hidden" id="popup_load_id" name="popup_load_id"  onClick={() => this.handleLoadPopup(post_id)}  />
                                <input type="hidden" id="reply_id" name="reply_id" />
                                <input type="hidden" id="activity_parent_id" name="activity_parent_id" />
                                <a href ="javascript:void(0);"  className='like-icon liked1'  id={post_like_id_m}>
                          <img  id={post_like_id_m}  onClick={() => this.handlePhotoLike(post_id,'popup')} className="default1" src="../images/like-new.svg"/>
                          <img  id={post_like_id_m}  onClick={() => this.handlePhotoUnLike(post_id,'popup')}  className="active1"  style={{ display: "none" }}   src="../images/like-fill.svg"/>{this.handleGetLikePost(post_id)}
                        </a>
                            <a href="javascript:;"  onClick={() => this.handleCommentClick()}  className="comment-icon home-comment">
                              <img src="../images/comment-bold.svg" alt="Comment" />
                            </a>
                            <a href="javascript:;" className="share-icon">
                              <img src="../images/cmt-share-bold.svg" alt="Share" />
                            </a>
                          </div>
                          <div className="post_save1">
                          {/* <a href="javascript:;" className="savepost_link">
                              <img className="savedefault" src="../images/bookmark-bold.png" alt="No BookMark" />
                              <img className="saveactive" src="../images/bookmark-fill.svg" alt="No BookMark" style={{ display: "none" }} />
                            </a>*/}
                          {getLoggedinUsername!=null?
                          <a href ="javascript:void(0);"  style={{ display: "block" }}  id={post_id_m}  className='savepost_link1' >                   
                            <img id={post_id_m} style={{ display: "block" }} className="savedefault1" src="../images/bookmark.svg" onClick={() => this.handleSavePost(post_id,'popup')} alt='No BookMark' />
                            <img id={post_id_m} style={{ display: "none" }} className="saveactive1" src="../images/bookmark-fill.svg" onClick={() => this.handleRemoveSavePost(post_id,'popup')} alt='BookMark' />
                            {this.handleGetSavePost(post_id,'popup')}
                          </a>
                          : <a href="javascript:void(0);"  onClick={() => this.handleNotLoginClick()}>
                            <img style={{ display: "block" }} className="savedefault1" src="../images/bookmark.svg"  alt='No BookMark' />
                          </a>
                          }
                          </div>
                        </div>                       
                        {fetchuserlikeusername}
                      
                        


                 
                    </div>

      
        {showPicker && (
          <Picker onEmojiClick={this.onEmojiClick} />
        )}






                  
                      
                    <div className="add_in_comment">
                      <div className="emoji_icon_input_row">
                        <div className="emogi_icon"> <img src="../images/add_reaction.svg" alt='img'  onClick={this.togglePicker} />
                    


                      </div>
                      <div className="textarea_bottom active">

            
                            <MentionsInput  placeholder="Add a comment..." value={this.state.singlementioned_popup}  id="comment_box_popup"   onChange={ this.updateInputPopup} style={defaultStyle}  onKeyDown={this.handleSinglePostPopupEnter}>
                              <Mention trigger="@" data={this.state.singleget_allusers_popup}   markup="@__display__ "
                                displayTransform={(id, display,displayName) => `@${display}`}
                                appendSpaceOnAdd  style={defaultMentionStyle}  renderSuggestion={this.singlerenderUserSuggestionPopup}
                                required id="comment_box_popup" className="mentions__mention"    placeholder="Add a comment..."/>
                            </MentionsInput>
                            </div>
                                                    {/*  <button className="post_button_comment">Post</button>*/}
                            {this.state.singlementioned_popup===''?<button   id='handleCommentPost_popup' disabled className="post_button_comment" onClick={this.handleCommentPostPopup}>Post</button>:<button   id='handleCommentPost_popup' className="post_button_comment" onClick={this.handleCommentPostPopup}>Post</button>}
                             <button  style={{ display: "none" }}  onClick={clearInput} id="clearInput">Clear Input</button>
                             {this.state.loader && <div className="loading_img"  style={{'position': "absolute", 'top': "50%", 'left': "50%",'transform':"translate(-50%, -50%)"}}   ><img style={{'width': "40px"}}  src="/images/loading-gif.gif" /></div>}
                              {/*<button   id='handleCommentPost_popup' className="post_button_comment" onClick={this.handleCommentPostPopup}>Post</button>*/}
                      </div>
                      <small><p className='comment_message_alert'>{this.state.blank_comment_message_popup}</p></small>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
      {/*Single Post Overlay Likes Now popup*/}
      <div className="modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image" id="large_challenge_like_list" onKeyDown={this.singlePostLikeModalClose} data-backdrop="false" data-keyboard="true" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className='action-part'>
              <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close"  onClick={this.singlePostLikeModalClose}  title='Close'>&#x2715;</a>
            </div>
            <div className="modal-body">
              <div className='inner text-center'>
              <div className="likes_user_model">
                    <div className="likes_model_row">
                      <h1 className="like_title">Likes</h1>
                      
                    </div>
                    <div className="model_likes_main">
                      
                      <ul className="like_total_list">
                      {bufferfollowers}
                   
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*Single Post Overlay Likes Now end popup*/}

       {/*Single Post Overlay Likes Now end popup likes*/}

      <div className="modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image" id="large_challenge_like_list_likes1" onKeyDown={this.singlePostLikeModalClose} data-backdrop="false" data-keyboard="true" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className='action-part'>
              <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close"  onClick={this.singlePostLikeModalClose}  title='Close'>&#x2715;</a>
            </div>
            <div className="modal-body">
              <div className='inner text-center'>
              <div className="likes_user_model">
                    <div className="likes_model_row">
                      <h1 className="like_title">Likes</h1>
                      
                    </div>
                    <div className="model_likes_main">
                      
                      <ul className="like_total_list">
                      {bufferlikefollowers}
                   
                      </ul>
                    </div>
                  </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      


      {/*Single Post Overlay Likes Now end popup likes*/}
      {/*delete post*/}
      <div className="modal fade post_modal post_modal_overlay deletePostCloseModalpopup" id="deletePostCloseModalpopup" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className='inner text-center'>
                <div className='title-main'>
                  <h6>Are you sure you want to delete this post?</h6>
                </div>
                <div className='action-part'>
                {/* onClick={(e) => this.checkDeletePost(page)} */}
                  <input type="hidden" id="delete_post_id" name="delete_post_id" />
                  <a href='javascript:void(0);'   onClick={(e) => this.checkDeletePost()}  className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close" title='Delete'>Delete</a>
                  <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*delete post*/}
    </React.Fragment> 
    );
  };

 singlerenderUserSuggestion = (suggestion, search, highlightedDisplay) => (
    <div className="user-suggestion">
      <img src={suggestion.avatar} alt={suggestion.display} className="user-avatar" />
      <div className='details'>
        <span className="displayUserName">{highlightedDisplay}</span>
        <span className="displayName">{suggestion.displayName}</span>
      </div>
    </div>
  );
 singlerenderUserSuggestionPopup = (suggestion, search, highlightedDisplay) => (
    <div className="user-suggestion">
      <img src={suggestion.avatar} alt={suggestion.display} className="user-avatar" />
      <div className='details'>
        <span className="displayUserName">{highlightedDisplay}</span>
        <span className="displayName">{suggestion.displayName}</span>
      </div>
    </div>
  );


 singlegetUsersCommentLike(post_id,main_activity_id) {
  let currentUser = Parse.User.current();
  if(currentUser)
  {
  //following
    var query = new Parse.Query('Activity');       
        query.include("user");
        query.include("image");
        query.include("toUser");
        query.include("thumbnail");
        query.equalTo("type", "follow");
        query.equalTo("fromUser", currentUser);
        var self = this;
        
        query.find().then(function(result){
            if(result){
               let resultcount=result.length;
               let followingdataresult1 = [];

               if (resultcount > 0)
               {
                   let userdataresult1 = [];
                   
                   for (var i = 0; i < resultcount; i++)
                   {
                     var user = result[i];
                     let userimage='';
                     if(user.get("toUser").get("profilePictureSmall") && user.get("toUser").get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("toUser").get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }     
                     //console.log(user.get("fromUser").id);
                     //console.log(user.get("toUser").id);
                     userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id,});
                     followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});
                     self.setState({followinglikeuserid: followingdataresult1});                      
                    }
               }else{
                  self.setState({followinglikeuserid: []});  
               }
            }
        })

   //followers 
   var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('activity', "Activity$"+main_activity_id);
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (followerresult.length > 0)
               {
                       let userdataresult = [];                      
                       //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followerslikeListing: userdataresult});
                        
               }
            }
        })
  }else{
    var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('activity', "Activity$"+main_activity_id);
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (resultcount > 0)
               {
                      let userdataresult = [];                      
                      //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followerslikeListing: userdataresult});
                        
               }
            }
        })

  }


  } 
singlegetUsersLike(post_id) {
  let currentUser = Parse.User.current();
  if(currentUser)
  {

  //following
    var query = new Parse.Query('Activity');       
        query.include("user");
        query.include("image");
        query.include("toUser");
        query.include("thumbnail");
        query.equalTo("type", "follow");
        query.equalTo("fromUser", currentUser);
        var self = this;
        
        query.find().then(function(result){
            if(result){
               let resultcount=result.length;
               let followingdataresult1 = [];

               if (resultcount > 0)
               {
                   let userdataresult1 = [];
                   
                   for (var i = 0; i < resultcount; i++)
                   {
                     var user = result[i];
                     let userimage='';
                     if(user.get("toUser").get("profilePictureSmall") && user.get("toUser").get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("toUser").get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }     
                     //console.log(user.get("fromUser").id);
                     //console.log(user.get("toUser").id);
                     userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id,});
                     followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});
                     self.setState({followinguserid: followingdataresult1});                      
                    }
               }else{
                  self.setState({followinguserid: []});  
               }
            }
        })

   //followers 
   var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (followerresult.length > 0)
               {
                       let userdataresult = [];                      
                       //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followersListing: userdataresult});
                        
               }
            }
        })
  }else{
    var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (resultcount > 0)
               {
                      let userdataresult = [];                      
                      //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followersListing: userdataresult});
                        
               }
            }
        })

  }


  }
 singlegetAllUsersPopup() {
    var query = new Parse.Query('_User');
        query.limit(999999999);
        query.include("profilePictureSmall");
        query.include("displayUsername");
        query.exists("displayUsername");
        query.include("name");
        var self = this;
        query.find().then(function(result){
            let userdataresult1 = [];
            
            if(result){
                for (var i = 0; i < result.length; i++)
                   {
                  var user = result[i];
                    
                     let userimage='';
                     if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }  
                     //userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     //self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                     self.state.singleget_allusers_popup.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                 }
                     this.state.singleget_allusers_popup=userdataresult1;
            }else {
               // console.log("No users found");
            }
        }, function(error){
        });
       
  }
 singlegetAllUsers() {
    var query = new Parse.Query('_User');
        query.limit(999999999);
        query.include("profilePictureSmall");
        query.include("displayUsername");
        query.include("name");
        var self = this;
        query.find().then(function(result){
            let userdataresult1 = [];
            
            if(result){
                for (var i = 0; i < result.length; i++)
                   {
                  var user = result[i];
                    
                     let userimage='';
                     if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }  
                     //userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     //self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                     self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                 }
                     this.state.singleget_allusers=userdataresult1;
            }else {
               // console.log("No users found");
            }
        }, function(error){
        });
       
  }

      getUserProfileImage() {
        const currentUser = Parse.User.current();
        if (currentUser) {
           let profile_picture = currentUser.get("profilePictureSmall");
           if(profile_picture)
             { 
                 this.state.currentuserImage = profile_picture.url();
             }
               this.state.currentUserId = currentUser.id;
        }
      


      }
      
      renderComments() {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
        let buffer = [];

        if (this.state.comments && this.props.showComments) {
          for (var i = 0; i < this.state.comments.length; i++) {
            var comment = this.state.comments[i];
            let comment_activity_id="comment_"+comment.id;
            let comment_id="comnt_"+comment.id;
            this.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;
            var likesWord = "Likes";
            if (this.state.singlelikeCount == 1) likesWord = "Like";
            let comment_fromuserid= comment.get("fromUser").id;
            let comment_currentUserId= this.state.currentUserId;
            // if (ingredType != undefined)
            //console.log(comment.get('Photo').id);
            buffer.push(
              <div key={69*i} className="cmt_wrap">
                <div className='usr_img_detail'>
                  <div className='usr_img'>
                    <img src={this.getCommentProfilePic(comment)}/>                      
                  </div>
                  <div className="cmt_usr">
                    <div className='name'> 
                    {/* <a href={'/user/' + this.getUsername(comment.get("fromUser"))}>{this.getUsername(comment.get("fromUser"))}</a>*/}
                    {comment.get("fromUser").get('displayUsername')!=undefined?
                     <a href={'/user/' + comment.get("fromUser").get('displayUsername')}>{comment.get("fromUser").get('displayUsername')}</a>:""}
                     {/*<a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a>*/}
                      <span>{time_ago(comment.get("createdAt"))}</span>
                    </div>
                    <div className="action cta_btn">
                      <div className="btn-wrp btn-group more_action three-dot">
                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <img src="/images/dot_action.svg" alt="More Option"/>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                          {/*<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Delete</a>*/}
                          {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button" data-toggle="modal" data-target="#deleteCommentCloseModal"   onClick={(e) => this.deleteCommentId(comment_id)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report</a> }
                          <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cmt_box">
                    <div className="cmt_cnt" id={comment_id}>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)}</div>
                    <div className='comment_mn '>
                      <div className="post_action d-flex flex-column flex-wrap align-items-start w-100">
                        <div className='action_grp'>
                          {/* <a href = "../appstore" className='liked'>
                            <img className="default" src="../images/like.svg"/>
                            <img className="active" src="../images/like-fill.svg"/>
                          </a>*/}
                        
                          <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                            <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e);}}  className="activitydefault" src="../images/cmt-like.svg"/>
                            <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityUnLike(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>
                              {/* <button  data-id={comment.id} id={comment_activity_id}   onClick={this.handleGetActivityLikePost(comment.id)} >Cancel</button>*/}
                            {this.handleGetActivityLikePost(comment.id)}
                          </a>
                        </div>
                        <div className='comment_count'>
                          <span className="like box">
                            <a href="#">
                            {/* 6 Likes*/}{/*0 likes*/} {/*{comment.get("likeCount")?comment.get("likeCount"):0}*/} {this.state.singlelikeCount} {likesWord} 
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            );
          }
        }
        return ( <div className='cmt_wrap_list'>
                {buffer}
                </div>
        );
      }
      handleUnFollowUser = (touser_id) => { 
        const currentUser = Parse.User.current();
        if (currentUser) {         
          const currentUser_id = currentUser.id;
          var checksavequery = new Parse.Query('Activity');  
            checksavequery.equalTo('type', 'follow'); 
            checksavequery.equalTo('toUser', "_User$"+touser_id.id);
            checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
            checksavequery.find().then(function(resultAct){
                if(resultAct)
                {  
                     let activityresult=resultAct[0];
                     try {
                        activityresult.destroy();
                          setTimeout(() => {
                         $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: none");
                         $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: block");
                         },500);
                      } catch (error) {
                        console.error('Error deleting activity:', error);
                      }   
                 }
             })
               setTimeout(() => {
                   this.handleGetFollowUser(touser_id);
               },1000);
        }else
        {
            //window.alert('You need to login for follow user.');
            return false;
        }

      } 
      handleFollowUser = (touser_id) => {
        const currentUser = Parse.User.current();
        if (currentUser) {
            const currentUser_id = currentUser.id;  
            var Activity = Parse.Object.extend("Activity");
            var activity = new Activity();
            activity.set('fromUser', currentUser);
            activity.set('toUser', touser_id);              
            activity.set('type', 'follow'); 
            activity.save().then((savedFile) => {
                   setTimeout(() => {
                       //$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                       //$('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");
                       $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                       this.handleGetFollowUser(touser_id);
                       this.toggleNotification(touser_id,'started following you.','');
                       this.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                   },500);
            }).catch((error) => {
            });
        }else
        {
         
          $('#login_popup_btn').trigger('click');
          // $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }
      handleGetFollowUser = (touser_id) => {
        const currentUser = Parse.User.current();
        if (currentUser) {
          const currentUser_id = currentUser.id;
          var resultSavedid=0;
          var checksavequery = new Parse.Query('Activity');  
            checksavequery.equalTo('type', 'follow'); 
            checksavequery.equalTo('toUser', "_User$"+touser_id.id);
            checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
            checksavequery.find().then(function(resultSave){
                if(resultSave)
                {  
                      let resultSaved=resultSave[0];
                      resultSavedid= resultSaved.id;
                      $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                  
                }else
                {
                    
                }
            })
        }
      }
     // handleGetSavePost = (post_id,page) => {
       handleGetSavePost = (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id').val();
           post_id=posts_id;
        }
        //var check_value=0;
        const currentUser = Parse.User.current();
        if (currentUser) {
          const currentUser_id = currentUser.id;        
          var resultSavedid=0;
          var checksavequery = new Parse.Query('Save');  
          checksavequery.equalTo('photo', "Photo$"+post_id);
          checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
          checksavequery.find().then(function(resultSave){
              if(resultSave)
              {             
                  let resultSaved=resultSave[0];
                  resultSavedid= resultSaved.id;
                  let photo_id= resultSaved.get('photo').id;
                  if(resultSavedid)
                  {  
                      //$('.active#save_'+post_id).attr("style", "display: block"); 
                      //$('.default#save_'+post_id).attr("style", "display: none"); 
                      //$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
                      $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                      $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: block");
                      $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: auto"); 
                      if(posts_id)
                      {
                          $('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style", "display: none"); 
                          $('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style", "display: block");
                      }

                     
                  }  
              }
          })
        }
      }

      handleRemoveSavePost= (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id').val();
           post_id=posts_id;
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername) {
            //window.alert('You need to login to save post.');
            return false;
        }else {
          $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: none"); 
          var query = new Parse.Query('Photo');  
          query.equalTo('objectId', post_id);
          query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var saveCount= photo_ob.get('saveCount');
                         if(saveCount==undefined ||  saveCount < 0)
                         { 
                             saveCount=0;
                         }else
                         {
                            saveCount=saveCount-1;
                         }
                          
                            photo_ob.set("saveCount", saveCount);         
                            photo_ob.save();
                            let currentUser = Parse.User.current(); 
                            var checklikequery = new Parse.Query('Save');  
                            checklikequery.equalTo('photo', photo_ob); 
                            checklikequery.equalTo('fromUser', currentUser);  
                            checklikequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } else {
                                     $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: none");

                                     $('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style", "display: none");
                                }
                              })
                              .then((deletedObject) => {
                                     $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: none");

                                     $('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style", "display: none");
                                     $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: auto"); 
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });      
                    } else {
                        //console.log("No post found");
                    }

                }, function(error){
                     //   console.error("Error loading post Error: " + error);
                        //promise.error(error);
                });
                     setTimeout(() => {
                          var self = this;
                          self.handleGetSavePost(post_id,page);
                     },1000);
        }
      }
      handleSavePost = (post_id,page) => {

        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id').val();
           post_id=posts_id;
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            //window.alert('You need to login to save post.');
            return false;
        }else
        {
        $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: none"); 
        var query = new Parse.Query('Photo');  
        query.equalTo('objectId', post_id);
         var self = this;
        query.find().then(function(photo){
            //$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var saveCount= photo_ob.get('saveCount');
                         if(saveCount==undefined)
                         {
                             saveCount=1;
                         }else
                         {
                            saveCount=saveCount+1;
                         }
                          
                            photo_ob.set("saveCount", saveCount);                          
                            photo_ob.save();
                            var Save = Parse.Object.extend("Save");
                            var save = new Save();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            save.set('fromUser', currentUser);
                            save.set('photo', photo_ob);
                            save.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             save.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             save.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            //acl.setWriteAccess(photo_ob.get('user'), true); 
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            save.setACL(acl);
                            save.save().then((savedFile) => {
                                 //  window.alert('You Saved post.');
                                 //  window.location.href = "/";
                            }).catch((error) => {
                            });    
                          self.toggleNotification(post_id,'saved photo','');
                          self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});                   
                    } else {
                        //console.log("No post found");
                    }


                }, function(error){
                     //   console.error("Error loading post Error: " + error);
                        //promise.error(error);
                });
         setTimeout(() => {
                          var self = this;
                          self.handleGetSavePost(post_id,page);
                          /*if(posts_id)
                          {
                            self.handleGetSavePost(post_id,'popup');
                          }*/
                     },1500);
        }
      }
     
      handleGetLikePost = (post_id) => {
        var check_value=0;
        const currentUser = Parse.User.current();
        if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.equalTo('photo', "Photo$"+post_id);
            //checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
            checklikequery.equalTo('fromUser', currentUser);  
            //checklikequery.notContainedIn("activity");   
            checklikequery.doesNotExist("activity");
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;
                    if(resultLikedid!==undefined)
                    {  
                       $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: none");

                       $('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style", "display: block"); 
                       $('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style", "display: none");
                       $('a.liked1#like_'+post_id).attr("style", "pointer-events: auto");
                    }
                    if(resultLikedid===undefined){                     
                       $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: block");

                       $('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style", "display: none"); 
                       $('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style", "display: block"); 
                    }                              
                }
            })
      }
      }
 handleCommentClick= () => {
   $('.add_in_comment #comment_box_popup').focus(); 
 }
  handleCommentSingleClick= () => {
   $('.comment_list_mn  #comment_box').focus(); 
 }
      handlePhotoUnLike= (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           //post_id=post_id;
           //post_id=$('#popup_post_id').val();
           //posts_id=$('#popup_post_id').val();
          post_id=$('#popup_post_id').val();
          posts_id=$('#popup_post_id').val();
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
         //$('a.liked .active#like_'+post_id).attr("style", "display: none");
          $('a.liked1#like_'+post_id).attr("style", "pointer-events: none");
         const currentUser = Parse.User.current();
         if (currentUser) { 
         var query = new Parse.Query('Photo');  
            query.equalTo('objectId', post_id);
            //query.equalTo('user', currentUser);
            var self = this;  
            query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var likeCount= photo_ob.get('likeCountNew');
                         if(likeCount===undefined || likeCount===1)
                         {
                             likeCount=0;
                         }else
                         {
                            likeCount=likeCount-1;
                         }                          
                            photo_ob.set("likeCountNew", likeCount);  
                            photo_ob.save();  
                            var checklikequery = new Parse.Query('Like');  
                            checklikequery.equalTo('photo', photo_ob); 
                            checklikequery.equalTo('fromUser', currentUser);  
                            checklikequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                   $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                  $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                  if(posts_id)
                                  {
                                     $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }
                                 
                                } else {
                                   /* $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                    $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                    if(posts_id)
                                    {
                                      $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }*/
                                }
                              })
                              .then((deletedObject) => {
                                  self.handleGetLikeUser(post_id);
                                  self.handleGetLikePost(post_id);
                                 
                                  self.setState({likeCount:likeCount});  
                                        
                                  //self.setState({likeCount1:likeCount}); 
                                  //$('#home_fetch').trigger('click');
                                  $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                  $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                   if(posts_id)
                                  {
                                  $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                  $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                                                   
                                  var likesWord = "Likes";
                                  if (likeCount == 1) likesWord = "Like";
                                   $('.comment_mn #like_counts_'+posts_id).html(likeCount);
                                   $('.comment_mn #like_words_'+posts_id).html(likesWord);
                                   $('a.liked1#like_'+post_id).attr("style", "pointer-events: auto");
                                  /*if(likeCount==1)
                                  {
                                    likesWord = "Like";
                                   
                                  }*/
                                  }                                
                                  let likeCountNew=likeCount;
                                  $('#like_count_new').html(likeCountNew+' '+likesWord); 
                                  //$('#popup_post_id').val(posts_id);  
                                                          
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
                              $('#home_fetch').trigger('click');      
                                           
              }
          });
              /*setTimeout(() => {
                            var self = this;
                           self.handleGetLikeUser(post_id);
                           if(posts_id)
                           {                            
                             self.handleGetLikeUser(posts_id); 
                           }                                                  
                      },1500);*/
                    /*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },2000);*/
      }
        }
      }
      toggleNotification = (postid,msg,comment) => { 
      var self = this;
        self.setState(prevState => ({
          isNotificationOpen: !prevState.isNotificationOpen,
          post_Notification_Id: postid,
          post_Notification_Msg: msg,
          post_Notification_Comment:comment  
        }));
        //self.setState({ post_Notification_Id: postid });        
      };
      handleGetActivityLikePost = (comment_id) => {
         var check_value=0;
         let post_id=this.state.postID;
         const currentUser = Parse.User.current();
         if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.include("activity");
            checklikequery.equalTo('photo', "Photo$"+post_id);
            checklikequery.equalTo('activity',"Activity$"+comment_id);
            checklikequery.equalTo('fromUser', currentUser);    
            var self = this;
           
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;                    
                    if(resultLikedid!==undefined)
                    { 
                       $(' a.liked_activity .activitydefault#comment_'+comment_id).attr("style", "display: none");
                       $('a.liked_activity .activityactive#comment_'+comment_id).attr("style", "display: block"); 
                       $('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style", "display: block"); 
                      // $(' a.liked_activity#comment_'+comment_id).attr("disabled", false);
                       /*if ($('a.liked_activity#comment_'+comment_id).hasClass('disabled'))
                       {
                         $('a.liked_activity#comment_'+comment_id).removeClass('disabled'); 
                       }*/
                       $('a.liked_activity#comment_'+comment_id).attr("style", "pointer-events: auto");
                    }   
                    if(resultLikedid===undefined){  
                       $('a.liked_activity .activitydefault#comment_'+comment_id).attr("style", "display: block");
                       $('a.liked_activity .activityactive#comment_'+comment_id).attr("style", "display: none"); 
                        $('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style", "display: none"); 
                    }                            
                }
            })
        }
      }
      handlePhotoActivityUnLike = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
              if(!getLoggedinUsername)
              {
                  $('#kitchenQrModal_btn').trigger('click');    
                  return false;
              }else
              {
                  let  post_id=e.target.id;
                  let datapost_id=e.target.dataset.id;
                  //$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
                  $('a.liked_activity#comment_'+datapost_id).attr("style", "pointer-events: none");
                  var query = new Parse.Query('Activity');  
                  query.equalTo('objectId', datapost_id);
                  var self = this;
                  query.find().then(function(activity){
                          if(activity)
                          {
                              let activity_ob=activity[0];
                              let likeCount;
                              if (activity_ob) {
                                likeCount = activity_ob.get('likeCount');
                              } else {
                                likeCount =0;
                              }   
                              if(likeCount===undefined || likeCount===0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }                     
                              /*if(likeCount==undefined || likeCount < 0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }*/  
                              let photo_ob= activity_ob.get('photo');
                              activity_ob.set("likeCount", likeCount);
                              activity_ob.save();
                              //like 
                                  let currentUser = Parse.User.current(); 
                                  let currentUser_id=currentUser.id;                          
                                  var checklikequery = new Parse.Query('Like');  
                                  checklikequery.equalTo('photo', photo_ob); 
                                  checklikequery.equalTo('fromUser', currentUser);  
                                  checklikequery.equalTo('activity', activity_ob);
                                  checklikequery.first()
                                    .then((object) => {
                                      if (object) {
                                        return object.destroy();
                                      } else {
                                          $('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                          $('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                           $('.comment_userimg_inner .like.box.maincomment#'+datapost_id).attr("style", "display: none");
                                      }
                                    })
                                    .then((deletedObject) => {
                                        //self.setState({likeCount:likeCount});  
                                        //$('#home_fetch').trigger('click');
                                        self.setState({singlelikeCount:likeCount}); 
                                      $('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                      $('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                      $('a.liked_activity#comment_'+datapost_id).attr("style", "pointer-events: auto");
                                      
                                    })
                                    .catch((error) => {
                                      console.error('Error deleting record:', error);
                                    });  
                              //like  
                          }
                      })
                  setTimeout(() => {
                            var self = this;
                            self.handleGetActivityLikePost(datapost_id);
                      },500);
              }
      }
      handlePhotoActivityLike = (e) => { 
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
            let  post_id=e.target.id;
            let datapost_id=e.target.dataset.id;
            //$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: none");
            //$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("disabled", true);
            //if(('a.liked_activity .activitydefault#comment_'+datapost_id).attr('disabled') === 'true'){  return;}
            $('a.liked_activity#comment_'+datapost_id).attr("style", "pointer-events: none");
            //e.stopImmediatePropagation();
            

            var query = new Parse.Query('Activity');  
            query.equalTo('objectId', datapost_id);
            var self = this;

            query.find().then(function(activity){
                    if(activity)
                    {
                        let activity_ob=activity[0];
                        let likeCount;
                        if (activity_ob) {
                           likeCount = activity_ob.get('likeCount');
                        } else {
                           likeCount =0;
                        }                        
                         if(likeCount==undefined)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }
                         let photo_ob= activity_ob.get('photo');
                         activity_ob.set("likeCount", likeCount); 
                         activity_ob.save();
                         //like 
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set('activity', activity_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }
                             like.save().then((likeActivitySaved) => {      
                                    //if ($('a.liked_activity#comment_'+datapost_id).hasClass('disabled')){ return false;}               
                                    self.setState({singlelikeCount:likeCount}); 
                             }).catch((error) => {
                            });
                         //like  
                      self.toggleNotification(post_id,'liked comment',activity_ob);
                      self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                     }
                 })
            setTimeout(() => {
                      var self = this;
                      self.handleGetActivityLikePost(datapost_id);                       
                 },500);
        }
      }

  handleGetActivityLikePostChild = (comment_id) => {
         var check_value=0;
         let post_id=this.state.postID;
         const currentUser = Parse.User.current();

         if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.include("activity");
            checklikequery.equalTo('photo', "Photo$"+post_id);
            checklikequery.equalTo('activity',"Activity$"+comment_id);
            checklikequery.equalTo('fromUser', currentUser);    
           
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;        
                    if(resultLikedid!==undefined)
                    {  
                       $(' a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style", "display: none");
                       $('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style", "display: block"); 
                       $('.like.box.childcomment#child_'+comment_id).attr("style", "display: block");
                       //$('.comment_like  .comment.box a .reply_count#comnt_'+comment_id).trigger('click');
                       
                       $('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style", "pointer-events: auto");
                    }   
                    if(resultLikedid===undefined){  
                       $('a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style", "display: block");
                       $('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style", "display: none"); 
                        $('.like.box.childcomment#child_'+comment_id).attr("style", "display: none");
                        $('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style", "pointer-events: auto");
                    }                            
                }
            }) 
            // this.state.singlementioned_popup='';
          /*  var reply_id=$('#reply_id').val();
         if(reply_id==='')
          {
           this.state.singlementioned_popup='';
          }*/
            
             //setTimeout(() => {
                        //  var self = this;
                       //  self.handleCommentPostUpdate();
                    // },1000);
        }
      }


    handlePhotoActivityUnLikeChild = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
              if(!getLoggedinUsername)
              {
                  $('#kitchenQrModal_btn').trigger('click');    
                  return false;
              }else
              {
                  let  post_id=e.target.id;
                  let datapost_id=e.target.dataset.id;
                  //$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
                  //console.log('datapost_id'+datapost_id);
                  
                  $('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style", "pointer-events: none");
                  var query = new Parse.Query('Activity');  
                  query.equalTo('objectId', datapost_id);
                  var self = this;
                  query.find().then(function(activity){
                          if(activity)
                          {
                              let activity_ob=activity[0];
                              let likeCount;
                              if (activity_ob) {
                                likeCount = activity_ob.get('likeCount');
                              } else {
                                likeCount =0;
                              }                        
                              if(likeCount===undefined || likeCount===0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }  
                              let photo_ob= activity_ob.get('photo');
                              activity_ob.set("likeCount", likeCount);
                              activity_ob.save();
                              //like 
                                  let currentUser = Parse.User.current(); 
                                  let currentUser_id=currentUser.id;                          
                                  var checklikequery = new Parse.Query('Like');  
                                  checklikequery.equalTo('photo', photo_ob); 
                                  checklikequery.equalTo('fromUser', currentUser);  
                                  checklikequery.equalTo('activity', activity_ob);
                                  checklikequery.first()
                                    .then((object) => {
                                      if (object) {
                                        return object.destroy();
                                      } else {
                                          $('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                          $('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                          $('.like.box.childcomment#child_'+datapost_id).attr("style", "display: none");
                                      }
                                    })
                                    .then((deletedObject) => {
                                        //self.setState({likeCount:likeCount});  
                                        //$('#home_fetch').trigger('click');
                                        self.setState({singlelikeCountChild:likeCount});
                                        var likesWord = "Likes";
                                        if (likeCount == 1){ likesWord = "Like";}
                                        $('.like.box .count#childlike_'+datapost_id).html(likeCount);  
                                        $('.like.box .like_count#childlike_'+datapost_id).html(likesWord);  
                                        $('.like.box .like_count#childlike_'+datapost_id).attr("style", "display: none"); 

                                      $('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                     $('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                     $('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style", "pointer-events: auto");
                                     if(likeCount===0)
                                     {
                                      $('.like.box.childcomment#child_'+datapost_id).attr("style", "display: none");
                                     }
                                     
                                      
                                    })
                                    .catch((error) => {
                                      console.error('Error deleting record:', error);
                                    });  
                              //like  
                          }
                      })
                  setTimeout(() => {
                            var self = this;
                            self.handleGetActivityLikePostChild(datapost_id);
                      },2000);
              }
      }


  handlePhotoActivityLikeChild = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
            let  post_id=e.target.id;
            let datapost_id=e.target.dataset.id;
            $('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style", "pointer-events: none");
            var query = new Parse.Query('Activity');  
            query.equalTo('objectId', datapost_id);
            var self = this;
            query.find().then(function(activity){
                    if(activity)
                    {
                        let activity_ob=activity[0];
                        let likeCount;
                        if (activity_ob) {
                           likeCount = activity_ob.get('likeCount');
                        } else {
                           likeCount =0;
                        }                        
                         if(likeCount==undefined)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }
                         let photo_ob= activity_ob.get('photo');
                         activity_ob.set("likeCount", likeCount); 
                         activity_ob.save();
                         //like 
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set('activity', activity_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }
                             like.save().then((likeActivitySaved) => { 
                             var likesWord = "Likes";
                             if (likeCount == 1){ likesWord = "Like";}
                             $('.like.box .count#childlike_'+datapost_id).html(likeCount);  
                             $('.like.box .like_count#childlike_'+datapost_id).html(likesWord); 
                             if(likeCount===0)
                                     {
                                      $('.like.box.childcomment#child_'+datapost_id).attr("style", "display: none");
                                     }                  
                                    self.setState({singlelikeCountChild:likeCount}); 
                             }).catch((error) => {
                            });
                         //like  
                          self.toggleNotification(post_id,'liked comment',activity_ob);
                          self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});    
                     }
                 })
            setTimeout(() => {
                      var self = this;
                      self.handleGetActivityLikePostChild(datapost_id);
                 },2000);
           
        }
      }    

handleLoadPopup = (post_id) => {
  //console.log('handleLoadPopup');
   /*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },1500);*/
}
      
      handlePhotoLike = (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
          post_id=$('#popup_post_id').val();
          posts_id=$('#popup_post_id').val();
        }

        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        { 
            //$('a.liked .default#like_'+post_id).attr("style", "display: none");
          $('a.liked1#like_'+post_id).attr("style", "pointer-events: none");
            var query = new Parse.Query('Photo');  
            query.equalTo('objectId', post_id);
             var self = this;
            query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var likeCount= photo_ob.get('likeCountNew');
                         if(likeCount===undefined || likeCount===0)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }                         
                            photo_ob.set("likeCountNew", likeCount);      
                            photo_ob.save();
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }                  

                            like.save().then((likeSaved) => {
                                    self.setState({likeCount:likeCount}); 
                                  
                                    $('a.liked .default#like_'+post_id).attr("style", "display: none");
                                    $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                                    if(posts_id)
                                    {
                                       $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: none");
                                       $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: block");          
                                       $('.comment_mn #like_counts_'+posts_id).html(likeCount);

                                       var likesWord = "Likes";
                                       //if (likeCount == 1) likesWord = "Like";
                                        if(likeCount==1)
                                        {
                                          likesWord = "Like";
                                          $('.comment_mn #like_words_'+posts_id).html(likesWord);
                                        }                                       
                                    }
                                    let likeCountNew=likeCount;
                                    $('#like_count_new').html(likeCountNew+' '+likesWord);
                                    //$('#home_fetch').trigger('click');
                                     $('#popup_post_id').val(posts_id);
                                  // this.handleGetLikePost(post_id);
                                     self.handleGetLikePost(post_id);
                                     self.handleGetLikeUser(post_id);   
                                     
                                   
                            }).catch((error) => {
                            });  

                            
                                                                         
                    } else {
                    }
                }, function(error){
                });
                 setTimeout(() => {
                    var self = this;
                    this.toggleNotification(post_id,'liked photo','');
                    self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                    },1000);   
        }
      }
  
      updateInput(event){
         this.setState({singlementioned: event.target.value});
         this.setState({postcomment : event.target.value});
      }
      handleSinglePostPopupEnter(event){       
        if (event.key === "Enter") {
          $('.post_button_comment#handleCommentPost_popup').click();
        }
      }
      updateInputPopup(event){
        //console.log('updateInputPopup');
          var reply_id=$('#reply_id').val();
          if(reply_id==='')
          {
            //console.log('singlementioned_popup==='+event.target.value)
            this.state.singlementioned_popup='';
          }
        var self = this;
       
          this.setState({singlementioned_popup: event.target.value});
             
         this.setState({postcomment_popup : event.target.value});
         this.setState({ inputText: event.target.value });
         if(event.target.value!== null && reply_id==='') {
         
         } else {
          //console.log('Test2');
         }   

      }
   
      
      postHeaderText() {
        var headerText = ""; //disable timestamp 5/29/19 //time_ago(this.state.created_at);

        if (this.state.city)
        {

            headerText += this.state.city;

        }
     
        return headerText;
      }
      
      queryForComments() {
        var query = new Parse.Query('Activity');
        
        query.equalTo("photo", this.props.postData);
        query.equalTo("type", "comment");
        query.doesNotExist("activity");

        query.include("fromUser");
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
        //query.ascending("_created_at");
        query.descending("_created_at");

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({comments: result});

                //promise.resolve(result);
            } else {
               // console.log("No comments found");
               // promise.resolve(null);
            }
        }, function(error){
                //console.error("Error loading comments Error: " + error);
                //promise.error(error);
        });
      }
      queryForCommentspopup(photo_ob) {
        let post_id=this.state.single_post_id?this.state.single_post_id:'';//$('#popup_post_id').val();
        // console.log('single_post_id'+this.state.single_post_id); 
        if(post_id)
        {
          //console.log('queryForCommentspopup');
        var query = new Parse.Query('Activity');
        
        query.equalTo("photo", photo_ob);
       // query.equalTo('photo', "Photo$"+post_id);
        
        query.equalTo("type", "comment");

        query.include("fromUser");
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
        //query.ascending("_created_at");
        query.descending("_created_at");

        var self = this;

        query.find().then(function(result){
            if(result){
               // this.setState({commentsdatas: result});
            } else {
            }
        }, function(error){
        });

        }
        
      }

handleCommentPost = function(e){
        var Photo = Parse.Object.extend("Photo");
        var query = new Parse.Query(Photo);
        let photo_post_id=this.state.postID;
        var postcomment=this.state.postcomment;
        if(postcomment) {
          query.include("user");
          query.include("image");
          query.include("thumbnail");
          query.include("likeCountNew");
          query.include("saveCount");
          query.include("commentcount");
          query.include("_created_at");
          query.include("createdAt");
          query.exists("user");
          query.descending("createdAt");

          query.find({
            success: function(results) {
              if (results.length > 0) {
                results.forEach(function(photo) {                
                  if( photo.id===photo_post_id)
                  {
                      var Activity = Parse.Object.extend("Activity");
                      var activity = new Activity();
                      let currentUser = Parse.User.current(); 
                      activity.set('fromUser', currentUser);
                      activity.set('toUser', photo.get("user"));
                      activity.set('content', postcomment);                 
                      activity.set('type', 'comment');                    
                      activity.set('photo', photo);    
                      activity.set('likeCount', 0);  
                      
                      let currentUser_id=currentUser.id;                
                    
                      
                      activity.set("_wperm", {
                                "*": {
                                  "write": true 
                                }
                              });

                             
                              activity.set("_rperm", {
                                "*": {
                                  "read": true 
                                }
                              });

                            
                              activity.set("_acl", {
                                "*": {
                                  "read": true, 
                                  "write": true 
                                }
                              });
                          var acl = new Parse.ACL();
                          acl.setPublicReadAccess(true);
                          acl.setPublicWriteAccess(true);
                          acl.setWriteAccess(photo.get('user'), true); 
                          acl.setWriteAccess(currentUser_id, true); 
                          acl.setReadAccess(currentUser_id, true); 
                          
                          activity.setACL(acl);
                          var self = this;
                      try {
                          activity.save().then((savedActivity) => {
                            const activityId = savedActivity.id;
                            setTimeout(() => {
                                $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
                                $('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
                            },1000);                         
                          }).catch((error) => {
                           
                          });
                          $(".comment_box").val('');
                          $("#comment_box").val('');
                          var updated_photo_id=photo.get('id');
                          const Photo_single = Parse.Object.extend("Photo");
                          const Photoquery = new Parse.Query(Photo_single);
                          const photoId = photo.id;
                          Photoquery.get(photoId)
                            .then(photo => {
                              var commentcount_val=parseInt(photo.get('commentcount'));
                              if(isNaN(commentcount_val))
                              {
                                  commentcount_val=0;
                              }                             
                              var updated_comment_count=commentcount_val+1;
                              photo.set("commentcount", updated_comment_count.toString());
                              photo.save();
                              
                              
                            
                            })
                            .catch(error => {
                         
                            });
                      } catch (error) {
                         
                      }
                  }
                });

              } else {
                //console.log("No photos found.");
              }
              
            },
            error: function(error) {
             // console.error("Error fetching photos: " + error.code + " " + error.message);
            }
          });
         
          setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
              this.state.postcomment='';
              this.state.singlementioned='';
          },1500);
        }
        //photo.id = "photo_object_id";
        // console.log(photo.id);
        var self = this;
        let post_id=this.state.postID;
        if(postcomment!='') {

        } else {
          self.setState({blank_comment_message:"Your message box is empty. Please write a message to continue."});
          // window.alert('Please write some comment first!');
        }
        setTimeout(() => {
          self.setState({blank_comment_message:null}); 
        }, 3000);
      } 

      handleCommentPostPopup = function(e){
        const currentUser = Parse.User.current();
        if(currentUser) {
        $('.post_button_comment#handleCommentPost_popup').attr("disabled", true);
        this.setState({ loader: true });
        e.preventDefault();
        //$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");
      
        var Photo = Parse.Object.extend("Photo");
        var query = new Parse.Query(Photo);
        let photo_post_id=this.state.postID;
        var postcomment=this.state.singlementioned_popup;//this.state.postcomment_popup;
        let reply_id=this.state.reply_id;//$('#reply_id').val();
        let activity_parent_id=$('#activity_parent_id').val();
        var self = this;
        if(postcomment) {
          query.include("user");
          query.include("image");
          query.include("thumbnail");
          query.include("likeCountNew");
          query.include("saveCount");
          query.include("commentcount");
          query.include("_created_at");
          query.include("createdAt");
          query.exists("user");
          query.descending("createdAt");
          
          query.find({
            success: function(results) {
              if (results.length > 0) {

                results.forEach(function(photo) {                               
                  if( photo.id===photo_post_id)
                  {
                      var Activity = Parse.Object.extend("Activity");
                      var activity = new Activity();
                      let currentUser = Parse.User.current(); 
                      activity.set('fromUser', currentUser);
                      activity.set('toUser', photo.get("user"));
                      activity.set('content', postcomment);                 
                      activity.set('type', 'comment');   
                      if(reply_id)
                      {
                        activity.set('activity', 'Activity$'+activity_parent_id);
                      }        
                      activity.set('photo', photo);    
                      activity.set('likeCount', 0);  
                      
                      let currentUser_id=currentUser.id;                
                    
                        try {
                        activity.save().then((savedActivity) => {
                          const activityId = savedActivity.id;
                          self.setState({reply_thread_id:activityId});

                         // setTimeout(() => {
                             // $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
                              //$('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
                             
                         // },1000); 
                          if(reply_id)
                          {
                          self.toggleNotification(photo_post_id,'commented post reply',savedActivity);
                        }else{
                            self.toggleNotification(photo_post_id,'commented post',savedActivity);
                        }
                          self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});   

                          let captionusername='';
                          let captionusernameupdated='';
                          if(postcomment)
                          {
                             captionusername = postcomment.match(/@\w+/);
                               if (captionusername) {
                                captionusernameupdated=captionusername[0].substr(1);
                                 if(captionusernameupdated)
                              {
                                //self.toggleNotification(photo_post_id,'tagged you in a comment',savedActivity);
                                self.toggleNotification(photo_post_id,'mentioned you in a comment',savedActivity);
                                self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});  
                              } 
                              }             
                          }
                                           
                               
                                          
                        }).catch((error) => {
                         
                        });

                        $(".comment_box_popup").val('');
                        $("#comment_box_popup").val('');
                        var updated_photo_id=photo.get('id');
                        const Photo_single = Parse.Object.extend("Photo");
                        const Photoquery = new Parse.Query(Photo_single);
                        const photoId = photo.id;
                        Photoquery.get(photoId)
                          .then(photo => {
                            var commentcount_val=parseInt(photo.get('commentcount'));
                            if(isNaN(commentcount_val))
                            {
                                commentcount_val=0;
                            }                             
                            var updated_comment_count=commentcount_val+1;
                            photo.set("commentcount", updated_comment_count.toString());
                            self.setState({commentCount:updated_comment_count.toString()});
                            photo.save();      
                            self.setState({singlementioned_popup:''});  

                          
                          })
                          .catch(error => {                       
                          });
                             setTimeout(() => {
                              self.setState({singlementioned_popup:'',reply_id:''});
                              self.handleCommentPostUpdate(); 
                          },500);
            
                    } catch (error) {                       
                    }                     
                  }
                });
        

              } else {
              }
              
            },
            error: function(error) {
            }
          });
       

         
         
        }
        var self = this;
        let post_id=$('#popup_post_id').val();
      }else
      {
        $('#kitchenQrModal_btn').trigger('click');  
          return false;
      }
      
      }

      cancelText(event){
        var postcomment=this.state.postcomment;       
        setTimeout(() => {             
            this.state.postcomment='';
            $(".comment_box").val('');
        },500);  
      }
      toggleExpand(commentId) {
        this.setState((prevState) => ({
            isExpanded: !prevState.isExpanded
        }));
         this.setState((prevStates) => ({
            expandedCommentId: commentId
        }));
      }
      deleteCommentId(commentId) {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];
        $('#delete_comment_id').val(commenUpdatedId);
      }
      
      deleteCommentIdOverlay(commentId) {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];
        $('#delete_comment_id').val(commenUpdatedId);
        this.checkDeleteComment();
      }
     
      checkDeleteComment() {
     
        let delete_comment_id= $('#delete_comment_id').val();    
        const currentUser = Parse.User.current();
        let photo_post_id=this.state.postID;
        var self = this;

        if(currentUser) {
          /*child*/ 
          var query_activityChild = new Parse.Query('Activity');  
          query_activityChild.equalTo('activity', "Activity$"+delete_comment_id);
          query_activityChild.equalTo('fromUser', currentUser);
          query_activityChild.find().then((object) => {

          if (object) {
            
               for (const objects of object) {
                              objects.destroy();
                              var checklikequery = new Parse.Query('Like');  
                              checklikequery.equalTo('photo', "Photo$"+photo_post_id);
                              //checklikequery.equalTo('fromUser', currentUser);
                              checklikequery.equalTo('activity', "Activity$"+objects.id);
                              checklikequery.find().then((object) => {
                                  if (object) {
                                      for (const objects of object) {
                                            objects.destroy();
                                      }
                                  }
                                })
                                .then((deletedObject) => {

                                })
                                .catch((error) => {
                                  console.error('Error deleting record:', error);
                                });
                        }
              //return object.destroy();
          } 

          }).then((deletedObject) => {
            /*setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },500);*/
          }).catch((error) => {
            console.error('Error deleting record:', error);
          }); 

          /*child*/

          /*like*/
          var checklikequery = new Parse.Query('Like');  
          checklikequery.equalTo('photo', "Photo$"+photo_post_id);
          //checklikequery.equalTo('fromUser', currentUser);
          checklikequery.equalTo('activity', "Activity$"+delete_comment_id);
          checklikequery.find().then((object) => {
              if (object) {
                  for (const objects of object) {
                        objects.destroy();
                  }
              }
            })
            .then((deletedObject) => {

            })
            .catch((error) => {
              console.error('Error deleting record:', error);
            });

        /*like*/




          var query_activity = new Parse.Query('Activity');  
          query_activity.equalTo('objectId', delete_comment_id);
          //query_activity.equalTo('fromUser', currentUser);
          query_activity.first().then((object) => {

          if (object) {
              //var photo_obj_id= object.get('photo').id;         
              /*photo*/
              /*var query = new Parse.Query('Photo');  
              query.equalTo('objectId', photo_obj_id);
              query.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var photoid= photo_ob.id;
                  var commentcount= photo_ob.get('commentcount');
                  if(commentcount==undefined || commentcount===1 || commentcount < 0)
                  {
                      commentcount=0;
                  }else
                  {
                      commentcount=commentcount-1;
                  } 
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                  }
              });*/
              /*photo*/
              return object.destroy();
          } 

          }).then((deletedObject) => {

           /* var getActivityquery = new Parse.Query('Activity');  
          getActivityquery.equalTo('objectId', delete_comment_id);
          var self = this;
          getActivityquery.find().then(function(activitydata){
          if(activitydata)
          {
              let activity_ob=activitydata[0];
              console.log(activity_ob.length);
            }
          })*/
        
        var query = new Parse.Query('Activity');
        let reply_id=this.state.reply_id;
        query.equalTo('photo', "Photo$"+photo_post_id);
        query.equalTo("type", "comment");
        //query.doesNotExist("activity");
        query.include("fromUser");
        query.include("photo");
        
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
       
        query.descending("_created_at");
        var self = this;

        query.find().then(function(result){
            if(result){
                let totalcomment=result.length;
                //console.log(totalcomment+'totalcomment')
                var getPhotoquery = new Parse.Query('Photo');  
                var self = this;
              getPhotoquery.equalTo('objectId', photo_post_id);
              getPhotoquery.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var commentcount= totalcomment?totalcomment:0;
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                     self.setState({commentCount:commentcount.toString()});
                     // setTimeout(() => {
                      //var self = this;
                     // this.handleCommentPostUpdate();
                    //},1000);
                  }
              });

              }
            });

        



            setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },1500);
          }).catch((error) => {
            console.error('Error deleting record:', error);
          }); 
        }   
      }
      deletePostId(post_id) {
        $('#delete_post_id').val(post_id);
      }
      checkDeletePost() {  
        let delete_post_id= $('#delete_post_id').val();  
        const currentUser = Parse.User.current();
        if(currentUser) { 
          var query = new Parse.Query('Photo');  
          query.equalTo('objectId', delete_post_id);
          var self = this;
          query.find().then(function(photo){
            if(photo) {
                let photo_ob=photo[0];
                var checklikequery = new Parse.Query('Like');  
                checklikequery.equalTo('photo', "Photo$"+delete_post_id);
                checklikequery.find().then((object) => {
                    if (object) {
                        for (const objects of object) {
                              objects.destroy();
                        }
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 

                var checkActivityquery = new Parse.Query('Activity');  
                checkActivityquery.equalTo('photo', "Photo$"+delete_post_id);
                checkActivityquery.find().then((object) => {
                    if (object) {
                          for (const objects of object) {
                              objects.destroy();
                        }
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                var checkSavequery = new Parse.Query('Save');  
                checkSavequery.equalTo('photo', "Photo$"+delete_post_id);
                checkSavequery.find().then((object) => {
                    if (object) {
                        for (const objects of object) {
                              objects.destroy();
                        }                       
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                  if(photo_ob)
                  {
                      photo_ob.destroy();  
                  }
                    setTimeout(() => {
                      window.location.href = "/";
                    },500);             
            }
          })
        }
      }
      formatComment(origComment) {
        if (!origComment)
          return "";

        var stringSplit = origComment.split(" ");
        var result = "";

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                result += '<a href="/appstore">' + comp + '</a> ';
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                result += '<a href="' + comp + '"">' + comp + '</a>';
            }
            else
            {
                result += comp;
            }
            result += " ";
        }
        return result;
      }
      renderComment(comment) {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;

        let buffer = [];

        var cmt = this.formatComment(comment);

        buffer.push(cmt);

        return ( <div>
                {buffer}
                </div>
        );
      }
      formatRenderComments(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }
        var self = this;

        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            //console.log(comp);
            comp=comp.replace(/<[^>]+>/g, "");
             let userdisplaynames ='';
            var firstChar = comp.charAt(0);

            /*if (firstChar == "#")
            {
                buffer.push(comp);
            }*/
             if (comp.indexOf("#") !== -1)
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                //var userdisplayname = comp.replace('#','');
                let linkdata='<a>'+comp+'</a>';
                buffer.push(linkdata);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                //buffer.push(<a href={comp}>{comp} </a>);
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            }
            else if (comp.indexOf("@") !== -1)
            {
                const regex = /@(\w+)/g;
                const linkedText = comp.replace(regex, '<a href="/user/$1">@$1</a>');
              //console.log(linkedText);
              //console.log(self.state.singleget_allusers);
               /*if(self.state.singleget_allusers.includes(comp))
               {
                console.log(self.state.singleget_allusers);
               }*/
              /*if (self.state.singleget_allusers) {
                for (var i = 0; i < self.state.singleget_allusers.length; i++) {
                  var display = self.state.singleget_allusers[i];
                  let displayid=display.id;
                  console.log(displayid);

                }
              }*/
              /*let linkdatas = singleget_alluserss.display.find(function(ele) {
                   ele.display === comp;
                   console.log(comp+'comp');
                   console.log(ele.display+'ele.display');
              });*/
              /*const index = singleget_allusers.display.findIndex((el) => el === comp)
              arr[index] = 0;
              if(self.state.singleget_allusers.display.includes(comp))
              {
                linkdata= self.state.singleget_allusers.display;
              }*/
               //let linkdatas='';
               /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })*/
              //replace(/<[^>]+>/g, "")

               //let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
              // userdisplaynames = comp.replace('@','');
              //let linkdata='<a href ='+window.location.origin+'/user/'+userdisplaynames+'>'+comp+'</a>';
                 // buffer.push(linkdata);  
                buffer.push(linkedText);
            }
            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
// Replace the item at the found index

// The new array with the replaced item
///<[^>]+>/g, ""


        var content=buffer.join(' ');
       // var data=content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content;
         var data=content.length > maxLength ? `${content.substring(0, maxLength)}...` : content;
       
             return ( <span className='cmt-txt'>

                {/*{buffer}*/} 
            {/* {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}  href={this.state.postLink}*/}
              <span dangerouslySetInnerHTML={{ __html: data }} />
             {content.length > maxLength && <a  href="javascript:;"  onClick={() => this.openPopup(this.state.postID)}  >more</a>}
                </span>
        );
      }
      formatRenderComment(origComment,comnt_id, comment_id) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=250;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);
             var self = this;
            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
               // buffer.push(<a href={comp}>{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {

              /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  
             }
            else
            {
                 // buffer.push(<span>{comp} </span>);  
                 //buffer.push(comp+' ');  
                 buffer.push(comp);               
            }
        }
        var content=buffer.join(' ');
            /* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/

        const {  showMoreText = 'more', showLessText = 'less' } = this.props;
        const { isExpanded } = this.state;
        const { expandedCommentId } = this.state;


        // Determine whether to truncate the text
        const shouldTruncate =content.length > maxLength && !isExpanded;
        
        // Truncate the text if necessary  //expandedCommentId===comment_id
        
           
        let  displayText =  shouldTruncate ? content.slice(0, maxLength) + '...' : content        
        return ( <span className='cmt-txt' id={comment_id}>
          {/*{buffer}*/} 
          {/*   {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "") }...` :content}*/}




          {/*  {content.length > maxLength && <a href={this.state.postLink}>more</a>}*/}
          {/*expandedCommentId===comment_id*/}
          {/*displayText*/}<span dangerouslySetInnerHTML={{ __html: displayText }} />
          {/* {displayText}*/}
          {shouldTruncate   && (
              <button onClick={() => this.toggleExpand(comment_id)} style={{ color: '#868589', cursor: 'pointer', border: 'none', background: 'none' }}>
                  {isExpanded ? showLessText : showMoreText}
              </button>
          )}
          </span>
        );
      }
      formatRenderComment_old(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }

        var self = this;
        var stringSplit = origComment.split(" ");

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
               // buffer.push(<a href={comp}>{comp} </a>);
                buffer.push(comp);
            }else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {
              /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata); */ 
               var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  

             }
            else
            {
                  // buffer.push(<span>{comp} </span>);  
                // buffer.push(comp+' ');  
              buffer.push(comp);  
               
            }
        }
        var content=buffer.join(' ');
        return ( <span className='cmt-txt'>
        {/*buffer*/}
              <span dangerouslySetInnerHTML={{ __html: content }} />
        </span>
        );
      }
      getUsername(user) {
         /*if ((!user) || (user == undefined))
            return "User";


          user.fetch();

          var username = user.get("displayUsername");

          if ((!username) || (username.length < 2)) 
          {
            username = user.get("firstName") + "_" + user.get("lastName");
            username = username.toLowerCase(username);
          }
          if ((!username) || (username.length < 2)) 
          {
            username = "facebook_user";
          }

          return username;*/

      }

      getCommentProfilePic(comment) {
          var user = comment.get("fromUser");
          if (user && (user != undefined))
          {
            var pic = user.get("profilePictureSmall");
            if (pic && (pic != undefined))
              return pic.url()
          }
          return "/images/default_userpic0.png";
      }
      renderTitleURL() {
        if (this.state.title || this.state.url)
        {
            var urlDomain = this.state.url.replace('http://','').replace('https://','').split(/[/?#]/)[0];
            urlDomain = urlDomain.replace('www.', '');

            if (!(this.state.url && (this.state.url.length > 1)))
            {
                return ( <div>
                          <div className="titleURLContainer">
                            <div className="titleText">{this.state.title}</div>
                          </div>
                      </div>
              );
            }
            else
            {
              return ( <div>
                      <a href={this.state.url} target="_blank">
                          <div className="titleURLContainer">
                            <div className="urlText">{urlDomain}</div>
                            <div className="titleText">{this.state.title}</div>
                          </div>
                          </a>
                      </div>
              );
            }
        }
        else
        {
            //don't show this section
            return ( <div></div>
              );
        }
      }
       formatRenderComments2main(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (comp.indexOf("#") !== -1)
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                //var userdisplayname = comp.replace('#','');
                let linkdata='<a>'+comp+'</a>';
                buffer.push(linkdata);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            } else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {
              //var userdisplayname = comp.replace(/\s/g, "").replace('@','');
                 const regex = /@(\w+)/g;
                const linkedText = comp.replace(regex, '<a href="/user/$1">@$1</a>');
              //let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                 // buffer.push(linkdata);  
                 buffer.push(linkedText);  
            }

            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
        var content=buffer.join(' ');
             return ({'a':<span className='cmt-txt'>
                        {/*  {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}
                          {content.length > maxLength && <a href={this.state.postLink}>more</a>}*/}
              {content}
                             </span>});
          //return <img src={"https:aaaa"} />
        
      }
      formatRenderComments2(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
               
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            }
            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
        var content=buffer.join(' ');
      
             return ({'a':<span className='cmt-txt'>
                             {/*{buffer}*/} 
                          {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}
                          {content.length > maxLength && <a href={this.state.postLink}>more</a>}
                             </span>});
        
      }
      handlePostModelOpen1 =  (post_id) => {
        this.setState({post_id : post_id});
      }
      handlePostModelOpen = async  (post_id) => {
    
       $('#home_id').val(post_id);
        
           
        
        
        $('#popup_post_id').val(post_id);

        $('.comment_like_shere .like-icon.liked1').attr('id','like_'+post_id);
        $('.comment_like_shere .like-icon.liked1 img.default1').attr('id','like_'+post_id);
        $('.comment_like_shere .like-icon.liked1 img.active1').attr('id','like_'+post_id);

        $('.post_save1 .savepost_link1 .savedefault1').attr('id','save_'+post_id);
        $('.post_save1 .savepost_link1 .saveactive1').attr('id','save_'+post_id);
        $('.post_save1 .savepost_link1').attr('id','save_'+post_id);
        
        
        $('#full_text').html('');
        $('#lef_img').attr('src','../images/default_userpic0.png');
        $('.popup_user_image').attr('src','../images/default_userpic0.png');
        $('.popup_display_userimage').attr('src','../images/default_userpic0.png');
        $('.user_name a.popup_user_name').html('');
        let getLoggedinUsername=localStorage.getItem('username');
      

            var query = new Parse.Query('Photo');  
            query.include("likeCountNew");
            query.include("commentcount");
            query.equalTo('objectId', post_id);
            //await query.get(post_id);
            var self = this;
          
            self.setState({single_post_id:post_id});
            
            self.setState({singlemodalstates:true});
  
 
       //comment listing
       let activity_data=[]; 
       var query1 = new Parse.Query('Activity');
       // query1.equalTo('photo', photo[0]);
        await query1.equalTo('photo', "Photo$"+post_id);
        //await query1.get(postId);
        
        query1.equalTo("type", "comment");

        query1.include("fromUser");
        query1.include("image");
        query1.include("content");
        query1.include("_created_at");
        query1.include("createdAt");
        //query.ascending("_created_at");
        query1.descending("_created_at");

        var self = this;

        query1.find().then(function(result){
            if(result){
               activity_data.push(result);
            

               
            
            } else {
            }
            
             
        

              self.setState({commentsdatas: activity_data[0]});
               

        }, function(error){
        });


       //comment listing  
           
             query.find().then(function(photo){
                    if(photo)
                    {
                      //self.setState({popup_username:null});
                      let photo_img =photo[0].get('image').url()? photo[0].get('image').url():'';

        

      


                      
                      $('#lef_img').attr('src',photo_img);
                       $('.time_interval_new').html(time_ago(photo[0].get('createdAt')));
                       
                          let obj = self.formatRenderComments2main(photo[0].get('caption'));
                       //console.log(photo_data+'photo_data');
                       
                      let full_text=obj?obj.a?obj.a.props?obj.a.props.children?obj.a.props.children:'':'':'':'';
                       $('#full_text').html(full_text);

                      let photo_data=photo[0].get('caption');
                      
                      let likeCountNew=photo[0].get('likeCountNew')?photo[0].get('likeCountNew'):0;
                      var likesWord = "Likes";
                      if (likeCountNew == 1) likesWord = "Like";
                      $('#like_count_new').html(likeCountNew+' '+likesWord);
                      
                      
                      $('.user_name a.popup_user_name').html(photo[0].get('user').get('displayUsername'));
                      $('.user_name a.popup_user_name').attr("href", "/user/"+photo[0].get('user').get('displayUsername')) ;
                      $('.user_name a.popup_display_username').html(photo[0].get('user').get('displayUsername'));
                       $('.user_name a.popup_display_username').attr("href", "/user/"+photo[0].get('user').get('displayUsername')) ;
                      
 
                       
                        let user_image =photo[0].get('user')?photo[0].get('user').get('profilePictureSmall')?photo[0].get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png';
                        
                      $('.popup_user_image').attr('src',user_image);
                        $('.popup_display_userimage').attr('src',user_image);
                    

      
                        }
              });
         return ( <div className=''>{/*<Modaldata  postData={post_id}/>  */} 
                </div>
        );
   
            
      }
      queryForSinglepost() {
        var post_id=  $('#popup_post_id').val();
        var query = new Parse.Query('Photo');
        query.equalTo('objectId', post_id);
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        query.descending("createdAt");

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({postData: result});
                self.setState({likeCount: result[0].get('likeCountNew')});
            } else {
                console.log("No post found");
            }
        }, function(error){
        });
    }

      popuprenderComments(){
       let bufferpopup = [];
        if (this.state.popup_comments) {
          for (var i = 0; i < this.state.popup_comments.length; i++) {
            var comment = this.state.popup_comments[i];
            let comment_activity_id="comment_"+comment.id;
            let comment_id="comnt1_"+comment.id;
            let comment_fromuserid= comment.get("fromUser").id;
          
            bufferpopup.push(
              <div key={69*i} className="cmt_wrap1">
                <div className='usr_img_detail1'>
                  <div className='usr_img1'>                   
                  </div>
                 
                </div>
             
              </div>
            );
          }
        }
         
        return ( <div className='cmt_wrap_lists'>
                {bufferpopup}
                </div>
        );

      }
  
      renderCaption() {
          if (this.props.showComments)
          {
            return ( 
              <div className="commentsContainer sngl_post_cmt">
                <div className="cmt_wrap">
                  <div className='usr_img'>
                    <img className="userProfileImage" src={this.state.userImage}/>
                  </div>
                  <div className='cmt_box'>
                   {/* <span className="cmt_usr"><a href={'/user/' + this.getUsername(this.state.user)}>{this.getUsername(this.state.user)}</a></span>*/}
                  <span className="cmt_usr"><a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a></span>
                    <span className="cmt_cnt_full">{this.formatRenderComment_old(this.state.caption)}</span>
                    
                  </div>
                </div>
              {/* <div className="cmt_time">{time_ago(this.state.created_at)}</div>*/}
              </div>                      
            );
          }
          else
          {
            //don't show the user and timestamp on the main stream view
            return (

              <div className="commentsContainer">
            
                <div className="home_pg">
                  <p className="cmt_box">
             
                    <span className="cmt_usr"><a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a></span>
                    <span className="cmt_cnt">{this.formatRenderComments(this.state.caption)}</span>
                  </p>
                </div>
              </div>
            );
          }
      }
      renderRecipeAndProduct() {
        if (this.props.showComments)
        {
              return ( 
              <div>
               {/* <Recipe recipe={this.state.recipe} />
                <Product product={this.state.product} />*/}
               </div>
              );
        }
        else
        {
            //don't show the user and timestamp on the main stream view
            return ( 
              <div>
               </div>
              );
        }
      }
      renderUserHeaderSharedALinkOrCollab(user, url, collabUser)
      {
        let getLoggedinUsername=localStorage.getItem('username');
          if (collabUser && (collabUser != undefined))
          {
          
                return ( 
                  <div className="usernameText">
              
                   {getLoggedinUsername===this.state.getUsernamefetch?
                  <a href="/my-profile">{this.state.getUsernamefetch}</a>
                  :<a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a>}
                  <span className="sharedA">
                    &nbsp;and&nbsp;</span>
                    <a href={'/user/' + collabUser}>{collabUser}</a>
                </div>
                );
          }
          else if (url)
          {
                return ( 
                  <div className="usernameText">
              
                    {getLoggedinUsername===this.state.getUsernamefetch?
                  <a href="my-profile"><div className="usernameText">{this.state.getUsernamefetch}  
                  <span className="sharedA">
                    &nbsp;shared a link</span>
                </div></a>
                :
                  <a href={'/user/' + this.state.getUsernamefetch}><div className="usernameText">{this.state.getUsernamefetch}  
                  <span className="sharedA">
                    &nbsp;shared a link</span>
                </div></a>
              }
                </div>
                );
          }
          else
          {
              //don't show the user and timestamp on the main stream view
              return (  <div className="usernameText">
            
                {getLoggedinUsername===this.state.getUsernamefetch?
                <a href="/my-profile">{this.state.getUsernamefetch}</a>:
                <a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a>}
              </div> );
          }
      }

      handleNotLoginClick = () => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }
      }

      singlePostModalClass() {
        $("body").addClass("sngl_mdl_open");
      }
      singlePostModalClose1() {
        var self = this;
        this.setState({isPopupOpen: false,
            postDetails: null,
            postDetailscomment: null});
        $("body").removeClass("sngl_mdl_open");
        $("body").removeClass("modal-open1");
        $("body").removeClass("modal-open");
        $('#popup_post_id').val('');
        //tabopenarray.length = 0;
        /*url update*/
        window.history.replaceState("","", "/");
        /*url update*/         
      }
      singlePostModalClose() {
        var self = this;
        $("body").removeClass("sngl_mdl_open");
        $("body").removeClass("modal-open1");
        $('#popup_post_id').val('');
        
      }

      singlePostLikeModalLikes(main_activity_id) {
        let post_id=$('#popup_post_id').val();        
        this.singlegetUsersCommentLike(post_id,main_activity_id);
           setTimeout(() => {
            $('#large_challenge_like_list_likes').trigger('click');
          },500); 
        $("body").addClass("sngl_mdlpstlk_open");
      }


      singlePostLikeModal() {
        let post_id=$('#popup_post_id').val();
        this.singlegetUsersLike(post_id);
        $("body").addClass("sngl_mdlpstlk_open");
      }
      singlePostLikeModalClose() {
        $("body").addClass("modal-open1");
        $("body").removeClass("sngl_mdlpstlk_open");
       // console.log("Test");
      }
       handleGetLikeUser = (post_id) => {
         //var  posts_id=$('#popup_post_id').val();
         if(post_id)
         {
          var like = new Parse.Query('Like');
          var self = this; 
          like.equalTo('photo', 'Photo$'+post_id);
          like.doesNotExist('activity');

          like.find().then(function(result){
              if(result)
              {              
                self.setState({likeuserlist:result}); 
              }              
          })
        }          
      }
    







      render() {

 const { isPopupOpen, loading, error, postDetails,postDetailscomment,loadingdata } = this.state;


        var likesWord = "Likes";
        var savesWord = "saves";
        var commentsWord = "Comments";
        var imprWord = "impressions";
        var page="home";
         var self = this;
        if(this.props.showComments) {
            page='single';
        }
        let getLoggedinUsername=localStorage.getItem('username');

        if (this.state.likeCount == 1) likesWord = "Like";
        if (this.state.saveCount == 1) savesWord = "save";
        if (this.state.commentCount == 1) commentsWord = "Comment";
        if (this.state.imprCount == 1) imprWord = "impression";

        var post_id_m='save_'+this.state.postID;
        var follow_id_m='follow_'+this.state.user.id;
        var currentuserImage=this.state.currentuserImage;
        var post_like_id_m='like_'+this.state.postID;
        var currentUserId=this.state.currentUserId;
        let sameprofile=0;
        if(currentUserId===this.state.user.id) {
          sameprofile=1;
        }
        //console.log(this.state.challengeStatus+'this.state.challengeStatus')
        var getchallengeStatus=this.state.challengeStatus;
        var isChallengeEntry=this.state.isChallengeEntry;
        var isChallengeWinner=this.state.isChallengeWinner;
        var isHideEntry=this.state.isHideEntry;
        var isRecipe=this.state.isRecipe;
        let isChallengeWinnersel=0;
        let isRecipesel=0;
        if(isChallengeWinner===true)
        {
          isChallengeWinnersel=1;
        }
        if(isRecipe===true)
        {
          isRecipesel=1;
        }

        let ischallengeStatus=0;
        let isHideEntryStatus=0;
      
        let iconclass='';
        if(this.state.isChallengeEntry=="1" && this.state.usertype===1 && this.state.challengeentrystatus=="Active")
        {
          iconclass='joinchallengein';
        }
        //getchallengeStatus==='Active' || 
        if(this.state.isHideEntry=="1"){
          isHideEntryStatus=1;
        }
        if(getchallengeStatus==='Billed' || getchallengeStatus==='Pending' || getchallengeStatus==='Complete' || getchallengeStatus==='Active')
        {
            ischallengeStatus=1;
        }
        var isNotificationOpen=this.state.isNotificationOpen; 
        var post_Notification_Ids=this.state.post_Notification_Id; 
        var post_Notification_Msg=this.state.post_Notification_Msg; 
         var post_Notification_Comment=this.state.post_Notification_Comment;
        if(ischallengeStatus == 0 || isChallengeEntry==1){

          return (


            <div className="post_details_section_main">

            {isNotificationOpen?<SaveNotification   isOpen={isNotificationOpen}  postNotificationid={post_Notification_Ids} postMsg={post_Notification_Msg} postPhotoid={this.state.postID} postActivityComment={post_Notification_Comment}  />:""}  

              {page==='single' ?

               <section className='post_list'  style={{ display: "none" }}>
                <div className='container'>
                  <div className='inner'>
                    <nav className='sidebar'>
                      <Leftsidebar />
                    </nav>
                    <main className='listing spd_page'>
                      <div className="spd_page_inner singlePostOverlayModal ">
                        <div className="inner text-center">
                          <div className="inner_post_row">
                            <div className="img_leftSide">
                              <img id="lef_img" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/c02b98ff933601a1ddd7930d8bd0f1bc_file.bin" alt="Comment" />
                            </div>
                            <div className="right_side_content_post">
                              <div className="user_top_row border_bottom">
                                <div className="user_top_card">
                                  <div className="user_img">
                                    <span className="user_icon">
                                      <img className="popup_user_image" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/599cddfce141ae7f0a7d86fd18168fd7_file.bin" alt="img" />
                                    </span>
                                  </div>
                                  <div className="user_name">
                                    <a className="popup_user_name" href="/user/rosslynmaria">rosslynmaria</a>
                                  </div>
                                </div>
                                <div className="action cta_btn">
                                  <div className="btn-wrp btn-group more_action three-dot">
                                    <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <img src="/images/dot_action.svg" alt="More Option" />
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                      <a href="javascript:void(0);" aria-label="Close" className="dropdown-item" type="button" title="Cancel">Cancel</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="post_listing_ul_wrap">
                                <ul className="post_listing_ul">
                                  <li className="post_listing_li">
                                    <div className="detail_bottom user_top_row">
                                      <div className="user_top_card">
                                        <div className="user_inline_row">
                                          <div className="user_leftbar_img">
                                            <div className="user_img">
                                              <span className="user_icon">
                                                <img className="popup_display_userimage" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/599cddfce141ae7f0a7d86fd18168fd7_file.bin" alt="img" />
                                              </span>
                                            </div>
                                            <div className="user_name_wrapper">
                                              <div className="user_inner">
                                                <div className="user_name">
                                                  <div></div>
                                                  <a href="/user/rosslynmaria" className="popup_display_username">rosslynmaria</a>
                                                  <span className="cmt_box">
                                                    <span className="cmt_cnt">
                                                      <span className="cmt-txt" id="full_text">This Grilled Peach Arugula Salad is inspired by summer and a must-try! 🍑🥗 The sweet, juicy peaches pair perfectly with peppery arugula, creamy vegan feta, and a drizzle of olive oil, balsamic vinegar, maple syrup and salt &amp; pepper to taste. It’s a quick and delicious way to celebrate the season! Recipe: • Grill Peaches: Slice 2 ripe peaches. Lightly brush with olive oil and grill for 2-3 minutes on each side until caramelized. • Prepare Salad: Toss a handful of fresh arugula with the grilled peaches and crumble vegan feta on top. • Make Dressing: Whisk together 2 tbsp olive oil, 1 tbsp balsamic vinegar, 1 tsp maple syrup, salt and pepper. Drizzle over the salad. • Serve &amp; Enjoy: Toss everything gently, serve immediately, and enjoy!! 🌞</span>
                                                    </span>
                                                  </span>
                                                  <span className="content-span"></span>
                                                </div>
                                                <div className="user_sidebar_heart"></div>
                                              </div>
                                              <div className="product_content_details">
                                                <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                  <div className="day box">
                                                    <a href="javascript:;">
                                                      <span className="time_interval_new">5d</span>
                                                    </a>
                                                  </div>
                                                  <div className="like box">
                                                    <a href="javascript:;" id="like_button_challenge" type="button" data-toggle="modal" data-target="#large_challenge_like_list">
                                                      <span id="like_count_new">3 Likes</span>
                                                    </a>
                                                  </div>
                                                  <div className="comment box"></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li className="post_listing_li">
                                    <div className="cmt_wrap">
                                      <div className="detail_bottom user_top_row">
                                        <div className="user_top_card">
                                          <div className="user_inline_row">
                                            <div className="user_leftbar_img">
                                              <div className="user_img">
                                                <span className="user_icon">
                                                  <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7dbb41bbd6e35056a861bd98d8786263_file.bin" />
                                                </span>
                                              </div>
                                              <div className="user_name_wrapper">
                                                <div className="user_inner">
                                                  <div className="user_name">
                                                    <a href="/user/joel">joel</a>
                                                    <span className="content-span">
                                                      <span className="cmt_cnt">
                                                        <span className="cmt-txt">
                                                          <span>Grilled peaches are definitely a summer seasonal treat! Simple, delicious, and healthy. The perfect trifecta. Thanks so much for sharing, Rosslyn. 🥗</span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                  <div className="user_sidebar_heart">
                                                    <a href="javascript:void(0);">
                                                      <img src="../images/like-fill.svg" />
                                                      <img src="../images/cmt-like.svg" />
                                                    </a>
                                                    <div className="like box maincomment">
                                                      <a href="javascript:;">
                                                        <span className="count">1</span>
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="product_content_details">
                                                  <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                    <div className="day box">5d</div>
                                                    <div className="comment box">
                                                      <a href="javascript:;">
                                                        <span className="reply_count">Reply</span>
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="cmt_wrap">
                                      <div className="detail_bottom user_top_row">
                                        <div className="user_top_card">
                                          <div className="user_inline_row">
                                            <div className="user_leftbar_img">
                                              <div className="user_img">
                                                <span className="user_icon">
                                                  <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/389fcf7e78aba3f4f5abd39780c837e1_file.bin" />
                                                </span>
                                              </div>
                                              <div className="user_name_wrapper">
                                                <div className="user_inner">
                                                  <div className="user_name">
                                                    <a href="/user/joelskitchen">joelskitchen</a>
                                                    <span className="content-span">
                                                      <span className="cmt_cnt">
                                                        <span className="cmt-txt">
                                                          <span>Super-duper, Rosslyn! Thanks so much for sharing. 🙏</span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                  <div className="user_sidebar_heart">
                                                    <a href="javascript:void(0);" className="liked_activity">
                                                      <img className="activitydefault" src="../images/cmt-like.svg" />
                                                    </a> {/* <div className="like box maincomment" id="Q6Or3VPqTI1">
                                                      <a href="javascript:;" id="like_button_challenge">
                                                        <span className="count">0</span>
                                                        <span className="like_count" style="display: none;">Likes</span>
                                                      </a>
                                                    </div>*/}
                                                  </div>
                                                </div>
                                                <div className="product_content_details">
                                                  <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                    <div className="day box">5d</div>
                                                    <div className="comment box">
                                                      <a href="javascript:;">
                                                        <span className="reply_count">Reply</span>
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                              <div className="comment_post_bottom_add">
                                <div className="comment_like_shere">
                                  <div className="wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100">
                                    <div className="action_grp">
                                      <input type="hidden" id="popup_post_id" name="popup_post_id" />
                                      <input type="hidden" id="popup_load_id" name="popup_load_id" />
                                      <input type="hidden" id="reply_id" name="reply_id" />
                                      <input type="hidden" id="activity_parent_id1" name="activity_parent_id1" />
                                      <a href="javascript:void(0);" className="like-icon liked">
                                        <img className="default1" src="../images/like-new.svg" />
                                      </a>
                                      <a href="javascript:;" className="comment-icon home-comment">
                                        <img src="../images/comment-bold.svg" alt="Comment" />
                                      </a>
                                      <a href="javascript:;" className="share-icon">
                                        <img src="../images/cmt-share-bold.svg" alt="Share" />
                                      </a>
                                    </div> 
                                     <div className="post_save1">
                                      <a href="javascript:void(0);" className="savepost_link1">
                                        <img className="savedefault1" src="../images/bookmark.svg" alt="No BookMark"  />
                                      </a>
                                    </div>
                                  </div>  
                                  <span>
                                    <p className="liked_others">
                                      <label>Liked by <span>
                                          <a href="/user/joel" id="like_button_challenge" type="button" data-toggle="modal" data-target="#large_challenge_like_list"> joel</a>
                                        </span>
                                        <span> and <a id="like_button_challenge" type="button" data-toggle="modal" data-target="#large_challenge_like_list">2</a> others </span>
                                      </label>
                                    </p>
                                  </span>
                                </div>
                                <div className="add_in_comment">
                                  <div className="emoji_icon_input_row">
                                    <div className="emogi_icon">
                                      <img src="../images/add_reaction.svg" alt="img" />
                                    </div>
                                    <div className="textarea_bottom active">
                                      <div>
                                        <div>
                                          
                                          <textarea placeholder="Add a comment..." ></textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <button  disabled className="post_button_comment">Post</button>
                                  </div>
                                  <small>
                                    <p className="comment_message_alert"></p>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border_top_middle"></div>
                      <div className="spd_page_grid">
                      <h3 className="more_post_title">More posts from <span>rosslynmarie</span></h3>
                        <div class="gridPostRow">
                          <div class="gridPost">
                              <a href="javascript:void(0);">
                                  <figure class="thumbnail">
                                      <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg"/>
                                  </figure>
                              </a>
                          </div>
                          <div class="gridPost">
                              <a href="javascript:void(0);">
                                  <figure class="thumbnail">
                                      <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                  </figure>
                              </a>
                          </div>
                          <div class="gridPost">
                              <a href="javascript:void(0);">
                                  <figure class="thumbnail">
                                      <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                  </figure>
                              </a>
                          </div>
                          <div class="gridPost">
                              <a href="javascript:void(0);">
                                  <figure class="thumbnail">
                                      <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                  </figure>
                              </a>
                          </div>
                        </div>
                      </div>
                    </main>
                  </div>
                </div>
              </section> 


              :""}

      
            <div className='post-card card'>
            


              <div className='card_inner'>

                <div className="user_card">
                  <div className="img">
                    <img src={this.state.userImage} />
                    <div className="name">
                      {this.renderUserHeaderSharedALinkOrCollab(this.state.user, this.state.url, this.state.collabUsername)}
                    </div>
                  </div>
                  <div className="action cta_btn d-flex flex-row flex-wrap align-items-center">
                    <div className='secondary-btn btn-wrp sml-btn'>
                    {sameprofile===0?<div>
                      <a href="javascript:void(0);"  id={follow_id_m}   data-id={this.state.user.id}      style={{ display: "block" }}    onClick={() => this.handleFollowUser(this.state.user)}  className='followpost_link' title="Follow">Follow
                      </a>
                   </div>
                      :""}
                      <FollowersUser  postData={this.state.user}/>  
                        {/*this.handleGetFollowUser(this.state.user)*/}
                    </div>



                    <div className='btn-wrp btn-group more_action three-dot'>
                      <button type="button" className="dropdown-toggle"   data-toggle="dropdown"   aria-haspopup="true" aria-expanded="false">
                    
                        <img src="/images/dot_action.svg" alt="More Option"/>
                      </button>
                      <div className="dropdown-menu dropdown-menu-right"  >
                      {sameprofile===1?
                      <a  href='javascript:void(0);'  className="dropdown-item danger" type="button" id="delete_post_with_discard"   data-toggle="modal" data-target="#deletePostCloseModal"   onClick={(e) => this.deletePostId(this.state.postID)} >Delete</a>
                      : <a  href='javascript:void(0);' className="dropdown-item danger" type="button">Report</a>}
                      <a href='javascript:void(0);'  data-dismiss="modal" aria-label="Close" className="dropdown-item" type="button">Cancel</a>

                      </div>
                    </div>
                  </div>              
                </div>
                <div className="hero_image">
              
                      {/* && isHideEntryStatus==="0" */}
                    {page=="home"? <div className='image_icon_wrap chlng-icon'>
                    {this.state.isChallengeEntry=="1" && this.state.usertype===1 && this.state.isHideEntry==="0" && this.state.challengeentrystatus=="Active"?            
                        <div className="join_challange"    style={{ 'backgroundColor': this.state.barcolor?'#'+this.state.barcolor:'#c13828' }} >
                           {/* href={'/challenge/'+this.state.challenge_id}*/}

                          <a  href="javascript:void(0);" onClick={(e) => this.hometaps(this.state.postID,this.state.challenge_id)}  id="large_challenge_image_challenge" className='sinlg_post_over_mdl'  type="button"  >Join Challenge Now<img src="/images/arrow_forward.svg" alt="Join Arrow"/></a>
                        
                        </div> 
                      :''}
                    <div className={iconclass?'iconGrp '+iconclass:'iconGrp'} >
                    {/*<div className='use-tag'><img src="../images/usertag-icon-img.svg"/></div>*/}
                    {isRecipesel===1?
                    <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>:""}
                    {isChallengeWinnersel===1?<div className='winner'><img src="../images/winner-icon-img.svg"/></div>:""}
                 
                    
                    </div><a href="javascript:;"  onClick={() => this.openPopup(this.state.postID)}  id="large_challenge_image_btn2" type="button" ><img className="img-thumbnail" src={this.state.postImage}/></a></div>:<div className='image_icon_wrap chlng-icon'><div className='iconGrp'>
                    {this.state.isChallengeEntry=="1" && this.state.usertype===1 && this.state.challengeentrystatus=="Active"?            
                        <div className="join_challange"    style={{ 'backgroundColor': this.state.barcolor?'#'+this.state.barcolor:'#c13828' }} >

                          <a href={'/challenge/'+this.state.challenge_id} id="large_challenge_image_challenge" className='sinlg_post_over_mdl'  type="button"  >Join Challenge Now<img src="/images/arrow_forward.svg" alt="Join Arrow"/></a>
                        
                        </div> 
                      :''}
                    {/*<div className='use-tag'><img src="../images/usertag-icon-img.svg"/></div>*/}
                    {isRecipesel===1?
                    <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>:""}
                    {isChallengeWinnersel===1?<div className='winner'><img src="../images/winner-icon-img.svg"/></div>:""}
                    {/*isChallengeEntry==1 && !isChallengeWinnersel?<div className='winner'><img src='/images/chlng-entry.png' className='chlng-wnr' /></div>:""*/}
                    
                    </div><a href='javascript:void(0);' id="large_challenge_image_btn2" type="button" data-toggle="modal" ><img className="img-thumbnail" src={this.state.postImage}/></a></div> }
                    
                    
                   
                      
                       <a href="javascript:;"  style={{ display: "none" }}  data-toggle="modal" data-target="#large_challenge_image3"   id="large_challenge_image_btn22" type="button" >modal</a>
                     
                </div>
                <div className="post_challange ">
                  <div className='cta_btn third-btn btn-wrp'>
                  {sameprofile===1 && this.state.isChallenge==0?
                    <a href={'/create-challenge/'+this.state.postID} title='Create Challenge'>Create Challenge</a>
                    :""}
                  </div>
                </div>
                {this.renderTitleURL()}  
                {/*------- post buttons -------*/}
             
                <div className="comment_mn">
                  <div className='post_action'>
                    <div className="wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100">
                      <div className='action_grp'>
                      
                        <a href ="javascript:void(0);"  className='like-icon liked'  id={post_like_id_m}>
                          <img  id={post_like_id_m}  onClick={() => this.handlePhotoLike(this.state.postID,page)} className="default" src="../images/like.svg"/>
                          <img  id={post_like_id_m}  onClick={() => this.handlePhotoUnLike(this.state.postID,page)}  className="active"  style={{ display: "none" }}   src="../images/like-fill.svg"/>{/*this.handleGetLikePost(this.state.postID)*/}
                           <GetLikePostHome  postIdData={this.state.postID} />  
                        </a>
                      
                        {getLoggedinUsername===null ? <a href="javascript:void(0);" className='comment-icon'  onClick={() => this.handleNotLoginClick()}>
                              <img src="../images/comment.svg" alt='Comment'/>
                            </a> :
                        getLoggedinUsername!=null && page==='home' ? <a href="javascript:void(0);"  className='comment-icon home-comment'  onClick={() => this.openPopup(this.state.postID)}  >
                                  <img src="../images/comment.svg" alt='Comment'/>
                                </a> :
                        getLoggedinUsername!=null && page==='single' ? <a href="javascript:void(0);"  onClick={() => this.handleCommentSingleClick()}   className='comment-icon single-comment ' >
                              <img src="../images/comment.svg" alt='Comment'/>
                            </a>:""}

                       
                        <a href = "../appstore" className='share-icon'>
                          <img src="../images/cmt-share.svg" alt='Share'/>
                        </a>
                      </div>
                      <div className='post_save'>
                        {getLoggedinUsername!=null?
                          <a href ="javascript:void(0);"  style={{ display: "block" }}  id={post_id_m}  className='savepost_link' >                   
                            <img id={post_id_m} style={{ display: "block" }} className="savedefault" src="../images/bookmark.svg" onClick={() => this.handleSavePost(this.state.postID,page)} alt='No BookMark' />
                            <img id={post_id_m} style={{ display: "none" }} className="saveactive" src="../images/bookmark-fill.svg" onClick={() => this.handleRemoveSavePost(this.state.postID,page)} alt='BookMark' />
                            {/*this.handleGetSavePost(this.state.postID,page)*/}  
                            <PostSaveUser  postIdData={this.state.postID} />  
                          </a>
                          : <a href="javascript:void(0);"  onClick={() => this.handleNotLoginClick()}>
                            <img style={{ display: "block" }} className="savedefault" src="../images/bookmark.svg"  alt='No BookMark' />
                          </a>
                        }
                        
                      </div>
                    </div>
                  </div>
                  <div className='like-count comment_count d-flex flex-row flex-wrap align-items-center'>
                    <div className="like box">
                    {/* <a href="javascript:;" id="large_challenge_image_btn2" type="button" data-toggle="modal" data-target="#large_challenge_image2">*/}
                      <a href="javascript:;"  onClick={() => this.openPopup(this.state.postID)} >
                      <span id={'like_counts_'+this.state.postID}>{this.state.likeCount}</span>
                      &nbsp;<span id={'like_words_'+this.state.postID}>{likesWord}</span>
                      </a>
                    </div>
                  </div>
                  <div className='comment_list'>
                    {this.renderRecipeAndProduct()}
                    {this.renderCaption()}
                  </div>
                  <div className='comment_count d-flex flex-row flex-wrap align-items-center'>
                    <div className="comment box">
                    {/* type="button" data-toggle="modal" data-target="#large_challenge_image2"*/}
                      <a href="javascript:;" id="large_challenge_image_btn2" data-id={this.state.postID}  onClick={() => this.openPopup(this.state.postID)} type="button">
                        View all {this.state.commentCount} {commentsWord}
                      </a>
                    </div>
                  </div>
                </div> 
                {/*------- caption -------*/}

                <div className="comment_list_mn " >
                  {getLoggedinUsername!=null  && this.props.showComments?
                    <div className="cmt_inpt_grp">
                      <div className='inptWrap'>
                        <div className='usr_img'>
                        

                          {currentuserImage!==null?
                            <img src={currentuserImage} alt='User Image'/>
                            :<img  src="/images/default_userpic0.png" />
                          }
                        </div> 
                        <div className='inpt_box'>
                        
                          <MentionsInput  placeholder="Add a comment..."  id="comment_box"   value={this.state.singlementioned}  onChange={this.updateInput} style={defaultStyle} >
                            <Mention trigger="@" data={this.state.singleget_allusers}   markup="@__display__ "
                            displayTransform={(id, display,displayName) => `@${display}`}
                            appendSpaceOnAdd  style={defaultMentionStyle}  renderSuggestion={this.singlerenderUserSuggestion}
                            required id="comment_box" className="mentions__mention"    placeholder="Add a comment..."/>
                          </MentionsInput>
                        
                        </div>
                        <p className='comment_message_alert'>{this.state.blank_comment_message}</p>
                      </div>
                      <div className='cmt_action_wrap'>
                        <button id='cancelCommentPost' className="cnlebtn"  onClick={this.cancelText} >Cancel</button>
                        <button id='handleCommentPost' className="postbtn" onClick={this.handleCommentPost}>Post</button>
                      </div>
                    </div>
                  
                  :''}
                  {this.state.loadpage==='single'?this.renderComments():''}        {/*this.renderComments()*/}
                </div>


              </div>


              {/*delete comment popup*/}
              <div className="modal fade post_modal post_modal_overlay deleteCommentCloseModal" id="deleteCommentCloseModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
                <div className='bg_overlay'></div>
                <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className='inner text-center'>
                        <div className='title-main'>
                          <h6>Are you sure you want to delete?</h6>
                        </div>
                        <div className='action-part'>
                          <input type="hidden" id="delete_comment_id" name="delete_comment_id" />
                          <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close"  onClick={this.checkDeleteComment} title='Discard'>Delete</a>
                          <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*delete comment popup*/}
              {/*delete post popup*/}
              <div className="modal fade post_modal post_modal_overlay deletePostCloseModal" id="deletePostCloseModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
                <div className='bg_overlay'></div>
                <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className='inner text-center'>
                        <div className='title-main'>
                          <h6>Are you sure you want to delete this post?</h6>
                        </div>
                        <div className='action-part'>
                          <input type="hidden" id="delete_post_id" name="delete_post_id" />
                          <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close"  onClick={(e) => this.checkDeletePost()} title='Delete'>Delete</a>
                          <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/*delete post popup*/}

             
              {/*Single Post Overlay popup*/}              
                <div className="modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image" id="large_challenge_image2" data-backdrop="false" data-keyboard="false" role="dialog" aria-labelledby="createPostCloseTitle" >
                  <div className='bg_overlay'></div>
                  <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                    <div className="modal-content">
                      <div className='action-part'>
                        <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' onClick={this.singlePostModalClose} data-dismiss="modal" aria-label="Close" title='Close'>&#x2715;</a>
                      </div>
                     
                    </div>
                  </div>
                </div>
           
                  {isPopupOpen && loading ? (
                    <p></p>
                  ) : error ? (
                    <p>{error}</p>
                  ) : (
                  postDetails && isPopupOpen && postDetailscomment && this.renderDetailPage(postDetails.id)
                  )}
              
            </div>
            </div>
         
          );
          }else{

            return(<span></span>);
          }
      }
}



export default SinglePost;



// WEBPACK FOOTER //
// ./src/singlepost.jsx